/* Language pack: fa */
export const translationsFa = {
	resumeRecording: "ادامه",
	chatCallMissed: "بی‌پاسخ",
	chatCallDeclined: "رد شده",
	chatAudioConference: "کنفرانس صوتی",
	chatVideoConference: "کنفرانس ویدیویی",

	IDCardImages: "تصاویر کارت شناسایی",
	IT: "فناوری اطلاعات",
	Status: "وضعیت",
	abbreviation: "اختصار",
	aboutUsItems: "آیتم‌های درباره ما",
	absent: "غایب",
	accept: "پذیرفتن",
	actSendingDate: 'تاریخ ارسال "عمل"',
	actionTimestamp: "برچسب زمانی اقدام",
	actionType: "نوع اقدام",
	actions: "اقدامات",
	activateStep7_8_9: "تخصیص به بخش خطوط انتقال نیرو ( 7, 8, 9 )",
	activateStep8: "تخصیص به بخش ژئودزی ( 8 )",
	activatedProjects: "پروژه‌های فعال شده",
	active: "فعال",
	activeCarts: "سبدهای خرید فعال",
	activeClients: "مشتریان فعال",
	activeCustomers: "مشتریان فعال",
	activeProjectSteps: "مراحل فعال پروژه",
	activePromos: "تبلیغات فعال",
	activeSales: "فروش‌های فعال",
	activeSalesEvents: "رویدادهای فروش فعال",
	activeServices: "سرویس‌های فعال",
	activeSteps: "مراحل فعال",
	activeStreams: "جریان‌های فعال",
	activeTasks: "وظایف فعال",
	activeTime: "زمان فعال",
	activity: "فعالیت",
	actualHours: "وقت فعلی",
	adInterval: "فاصله تبلیغاتی",
	adIntervalOverride: "قوانین برنامه ریزی",
	adIntervalOverrideDesc: "قوانین برنامه ریزی",
	adIntervalOverrideValue: "قوانین برنامه ریزی",
	adPlaylist: "لیست پخش تبلیغات",
	adPlaylists: "لیست‌های پخش تبلیغاتی",
	adTracks: "قطعات تبلیغاتی",
	add: "افزودن",
	addAttendance: "افزودن حضور",
	addFeature: "افزودن خاصية",
	addFeatureLine: "افزودن خط خاصية",
	addFiles: "افزودن فایل",
	addMoreFiles: "فایل های بیشتر اضافه کنید",
	addNew: "افزودن جدید",
	addPriceLine: "افزودن خط قیمت",
	addRule: "افزودن قانون",
	addToList: "اضافه به لیست",
	addVacationInterval: "افزودن بازه تعطیلات",
	added: "اضافه شد",
	additionalDetails: "جزئیات اضافی",
	address: "آدرس",
	addressData: "داده‌های آدرس",
	advanceDeductions: "کسور پیش‌پرداخت",
	advertisement: "تبلیغات",
	age: "سن",
	ageGroups: "گروه‌های سنی",
	ago: "پیش",
	agreedProjects: "پروژه‌های توافق شده",
	agreementAquipment: "توافق بر روی تجهیزات",
	aiConversations: "مکالمات",
	album: "آلبوم",
	allArtists: "همه هنرمندان",
	allAudioTracks: "همه قطعات صوتی",
	allContentItems: "همه آیتم‌های محتوا",
	allFilesDeleted: "تم حذف تمام فایل ها به طور دائم",
	allFilesWillBeDeleted: "تمام فایل‌ها برای همیشه حذف خواهند شد",
	allPlaylists: "همه لیست‌های پخش",
	allRegisteredContacts: "همه مشتریان ثبت‌نام شده",
	allTickets: "همه تذکره‌ها",
	amount: "مبلغ",
	analytics: "تحلیل",
	answer: "پاسخ",
	apartment: "آپارتمان",
	apply: "اعمال",
	appsMenu: "منوی برنامه‌ها",
	approved: "تأیید شده",
	approvedInterval: "بازه تأییدشده",
	archive: "آرشیو",
	archived: "آرشیو شده",
	areYouSure: "آیا مطمئن هستید؟",
	areYouSureToDelete: "آیا مطمئنید که می‌خواهید این را حذف کنید؟",
	artist: "هنرمند",
	artistObject: "شیء موزیکالی",
	assignedTo: "تخصيص",
	assignedToUser: "تخصیص به",
	assignmentToTheConstructionDepartment: "تخصیص به بخش ساخت و ساز",
	attach: "ضمیمه کردن",
	attachFile: "پیوستن فایل",
	attachments: "پيوست ها",
	attendance: "حضور و غیاب",
	attendanceFlag: "وضعیت حضور و غیاب",
	attendanceRequiringAttention: "کارمندانی که نیاز به توجه دارند",
	attendanceNoAttentionItems: "هیچ کارمندی نیاز به توجه ندارد",
	attendanceMissingCheckIn: "ورود ثبت نشده",
	attendanceMissingCheckOut: "خروج ثبت نشده",
	attendanceEarlyLeave: "ترک زودهنگام",
	attendanceEarlyMissings: "ترک‌های زودهنگام",
	attendanceEarlyMissingHours: "ساعات ترک زودهنگام",
	attendanceLateHours: "ساعات تأخیر",
	attendanceShowWorkedHours: "نمایش ساعات کارکرد",
	attendanceUnapprovedAbsence: "غیبت تأییدنشده",
	attendanceDeptAttendance: "حضور بر اساس بخش",
	attendanceDeviceHealth: "سلامت دستگاه و همگام‌سازی زنده",
	attendanceLastSync: "آخرین همگام‌سازی",
	attendanceLiveFeed: "فید زنده حضور و غیاب",
	attendanceNoRecentPunches: "اخیراً ثبتی وجود ندارد",
	attendanceManualEntryTag: "دستی",
	attendanceUnmappedPunch: "نامشخص",
	attendancePendingItems: "در انتظار",
	flexCardTotal: "کارت‌های Flex",
	attendanceCards: "کارت‌های حضور و غیاب",
	flexCardTotalSubtitle: "شناسه‌های Flex اختصاص‌یافته یا نادیده‌گرفته‌شده",
	flexCardsAttached: "متصل‌شده",
	flexCardsAttachedSubtitle: "شناسه‌های یکتای متصل به کاربران",
	flexCardsIgnored: "نادیده گرفته‌شده",
	flexCardsIgnoredSubtitle: "نادیده گرفته‌شده در تنظیمات منابع انسانی",
	flexCardsDuplicateAttached: "اتصال تکراری",
	flexCardIds: "شناسه‌های کارت",
	noDuplicateFlexCards: "بدون تکرار",
	attendanceTrendPctOfEmployeesPresent: "درصد حضور کارمندان",
	yesterday: "دیروز",
	attendanceFilterThisWeek: "این هفته",
	attendanceFilterThisMonth: "این ماه",
	attendanceFilterCustom: "سفارشی",
	attendanceSelectRange: "بازه را انتخاب کنید",
	attendanceCustomRangeCapped: "بازه سفارشی حداکثر ۹۰ روز است",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "حضور امروز",
	attendanceTitleYesterday: "حضور دیروز",
	attendanceTitleThisWeek: "حضور این هفته",
	attendanceTitleThisMonth: "حضور این ماه",
	attendanceTitleCustom: "حضور بازه انتخابی",
	attendanceTitleTodayKpis: "شاخص‌های حضور امروز",
	attendanceTitleYesterdayKpis: "شاخص‌های حضور دیروز",
	attendanceTitleThisWeekKpis: "شاخص‌های حضور این هفته",
	attendanceTitleThisMonthKpis: "شاخص‌های حضور این ماه",
	attendanceTitleCustomKpis: "شاخص‌های بازه انتخابی",
	attendanceTrendDays: "روند حضور — {n} روز اخیر",
	attendanceNotAttendedYet: "هنوز حاضر نشده",
	attendanceUpcomingAbsences: "غیبت‌های پیش رو",
	attendanceUpcomingAbsencesEmpty: "غیبتی در روزهای آینده وجود ندارد",
	attendanceUpcomingAbsencesTomorrow: "فردا",
	attendanceUpcomingAbsencesInDays: "{days} روز دیگر",
	attendanceExceptions: "استثناهای حضور و غیاب",
	attendanceExceptionsMissingCheckIn: "ورودهای ثبت‌نشده",
	attendanceExceptionsMissingCheckOut: "خروج‌های ثبت‌نشده",
	attendanceExceptionsEarlyLeaves: "ترک زودهنگام",
	attendanceExceptionsUnapprovedAbsences: "غیبت‌های تأییدنشده",
	attendanceExceptionsDuplicatePunches: "ثبت‌های تکراری",
	attendanceMonthlyKpis: "شاخص‌های ماهانه حضور",
	attendanceKpiRate: "نرخ حضور",
	attendanceKpiAvgArrival: "میانگین زمان ورود",
	attendanceKpiLateArrivals: "تأخیرها",
	attendanceKpiAbsentDays: "روزهای غیبت",
	attendanceKpiOvertimeHours: "ساعات اضافه‌کاری",
	attendanceLeaveBalanceOverview: "مرور مانده مرخصی",
	attendanceLeaveBalanceVacationRemaining: "مرخصی استحقاقی باقی‌مانده",
	attendanceLeaveBalanceSickUsed: "مرخصی استعلاجی استفاده‌شده",
	attendanceLeaveBalanceBusinessTrips: "سفرهای کاری",
	attendanceLeaveBalancePendingRequests: "درخواست‌های در انتظار",
	attendanceLeaveBalanceCoverage: "{covered} از {total} کارمند",
	attendanceTopInsights: "برترین بینش‌های حضور",
	attendanceInsightNoData: "هنوز داده‌ای موجود نیست",
	attendanceInsightHighestLateness: "{dept} بیشترین میزان تأخیر را این هفته دارد ({delta})",
	attendanceInsightFullAttendanceToday: "{dept} حضور ۱۰۰٪ داشته است",
	attendanceInsightTrendImproved: "حضور نسبت به دوره قبل {pct}٪ بهبود یافته است",
	attendanceInsightTrendDeclined: "حضور نسبت به دوره قبل {pct}٪ کاهش یافته است",
	attendanceInsightApproachingOvertime: "{count} کارمند به سقف اضافه‌کاری نزدیک می‌شوند",
	attendancePreviousWeek: "هفته گذشته",
	attendanceCurrentWeek: "این هفته",
	attendanceAddInterval: "افزودن بازه",
	attendanceBreakLabel: "وقفه",
	attendanceCorrectionMode: "حالت اصلاح",
	attendanceCustomIntervals: "بازه‌های سفارشی",
	attendanceDashboard: "داشبورد حضور",
	attendanceReports: "گزارش‌ها",
	attendanceCalendarTab: "تقویم",
	reports: "گزارش‌ها",
	shiftCoverage: "پوشش شیفت‌ها",
	previousPeriod: "دوره قبل",
	nextPeriod: "دوره بعد",
	failedToSave: "ذخیره نظر اضافه‌کاری ممکن نشد",
	expandForDailyDetail: "گسترش ردیف برای جزئیات روزانه",
	noDataForPeriod: "داده‌ای برای این دوره وجود ندارد",
	attendanceHistory: "تاریخچه حضور",
	attendanceDayOffTab: "تعطیل",
	attendanceDayType: "نوع روز",
	attendanceDetectedIntervals: "بازه‌های شناسایی‌شده",
	attendanceEditDay: "ویرایش روز",
	attendanceHrsTotal: "ساعت جمع",
	attendanceViewWeek: "هفته",
	attendanceViewMonth: "ماه",
	attendanceViewDay: "روز",
	day: "روز",
	attendanceOpenFrom: "باز از {time}",
	attendanceFromStillActive: "از {time} → هنوز فعال است",
	attendanceTotalWorked: "مجموع کارکرد",
	attendanceMissingUncovered: "غیبت / پوشش‌داده‌نشده",
	attendanceNoData: "داده‌ای وجود ندارد",
	attendanceNoDataForDay: "برای این روز داده حضور وجود ندارد.",
	attendanceIntervalApprovedOk: "تأیید شده / تأیید",
	attendanceIntervalEachRowInvalid: "برای هر بازه زمان شروع و پایان معتبر وارد کنید",
	attendanceIntervalTimesInvalid: "زمان شروع و پایان معتبر وارد کنید",
	attendanceIntervalsMode: "بازه‌ها",
	attendanceIntervalsReviewHint:
		"بازه‌های کاری واقعی، مرخصی و خلاصه را بررسی کنید. برای تأییدشده، کار، دورکار، مرخصی استعلاجی، با حقوق، بدون حقوق یا سایر، بازه‌های دستی اضافه کنید.",
	attendanceLogSubtitle: "ورود دستی حضور — کار، مرخصی استعلاجی، مرخصی",
	attendanceLogTitle: "گزارش حضور",
	attendanceManualResolutionIntervals: "بازه‌های دستی اصلاح",
	attendanceMissingLabel: "مفقود",
	attendanceNoManualIntervalsYet: "هنوز بازهٔ دستی اضافه نشده",
	attendanceNoUncovered: "بازهٔ پوشش‌نداده شناسایی نشد",
	attendanceOptionalNotePlaceholder: "یادداشت اختیاری…",
	attendancePtoLeaveSection: "مرخصی با حقوق / مرخصی",
	attendanceReport: "گزارش حضور",
	attendanceResolveInterval: "حل این بازه",
	attendanceResyncTooltip: "همگام‌سازی مجدد حضور و غیاب این کارمند",
	attendanceResyncSuccess: "همگام‌سازی مجدد حضور و غیاب آغاز شد",
	attendanceResyncFailed: "همگام‌سازی مجدد حضور و غیاب ناموفق بود",
	attendanceSavedSuccess: "حضور با موفقیت ذخیره شد",
	attendanceStatusUpcoming: "آینده",
	attendanceSelectEmployeePrompt: "کارمند را برای مشاهدهٔ حضور انتخاب کنید",
	attendanceTrend: "روند حضور",
	attendanceTrendPctPresent: "% حاضر",
	attendanceUncoveredMissing: "پوشش‌نداده / مفقود",
	attendanceUnsavedChanges: "تغییرات ذخیره‌نشده",
	attendanceWholeDayStatus: "وضعیت کل روز",
	shiftWorker: "کارگر شیفتی",
	attendanceIgnoreMode: "نادیده گرفتن",
	attendanceIgnoreScopeWeekdays: "روزهای هفته",
	attendanceIgnoreScopeDateRange: "بازه تاریخ",
	attendanceIgnoreScopeWeekdaysHint: "فقط در روزهای هفته انتخاب‌شده در این بازه اعمال می‌شود.",
	attendanceIgnoreScopeDateRangeHint: "به همه روزهای این بازه اعمال می‌شود.",
	attendanceIgnoreAppliesTo: "اعمال می‌شود به",
	attendanceIgnoreLateArrival: "تأخیر در ورود",
	attendanceIgnoreEarlyLeave: "خروج زودهنگام",
	attendanceIgnoreWindowStart: "شروع بازه نادیده‌گرفتن",
	attendanceIgnoreWindowEnd: "پایان بازه نادیده‌گرفتن",
	attendanceIgnoreRulesList: "قوانین نادیده‌گرفتن",
	attendanceIgnoreRulesEmpty: "هنوز قانونی ثبت نشده است",
	attendanceIgnoreDaysOfWeekRequired: "حداقل یک روز را انتخاب کنید",
	attendanceIgnoredLabel: "نادیده گرفته شد",
	attendanceNoCardLabel: "کارت ندارد",
	attendanceWork: "کار",
	attendanceWorked: "کار شده",
	attendanceWorkedIntervals: "بازه‌های کاری",
	attendanceMissingIntervals: "بازه‌های گم‌شده",
	attendanceStillInOffice: "هنوز در دفتر",
	attendanceAddEvent: "افزودن رویداد",
	attendanceAddAttendanceEvent: "افزودن رویداد حضور",
	attendanceDeleteEventTitle: "رویداد حضور حذف شود؟",
	attendanceDeleteEventText: "این فقط این رویداد ورود/خروج دستی را حذف می‌کند.",
	attendanceNoMissingIntervals: "برای این روز بازه گم‌شده‌ای نیست",
	attendanceOfficeSince: "از {time}",
	attendanceLastOutAt: "آخرین خروج {time}",
	attendanceEventSingular: "رویداد",
	attendanceEventPlural: "رویداد",
	attendancePunchIn: "ورود",
	attendancePunchOut: "خروج",
	solveThis: "حل شود",
	editSolvedStatus: "ویرایش وضعیت حل‌شده",
	officeStatus: "وضعیت دفتر",
	outOfOffice: "خارج از دفتر",
	noPunches: "ثبت ورود/خروج نیست",
	lastActionWasCheckIn: "آخرین عمل ورود بود",
	lastActionWasCheckOut: "آخرین عمل خروج بود",
	noCheckInYet: "هنوز ورود ثبت نشده",
	manual: "دستی",
	resolved: "حل‌شده",
	attendanceManualStatusApplyTicketTimeTo: "اعمال زمان تیکت روی",
	attendanceManualStatusColumnAttendanceType: "نوع حضور و غیاب",
	attendanceManualStatusColumnTimeAction: "عمل زمان",
	attendanceManualStatusMapsToType: "متناظر با نوع حضور و غیاب",
	attendanceManualStatusTicketTimeAction: "اقدام زمان خودکارسازی تیکت",
	attendanceTicketTimePhraseAdd: "افزودن زمان {type}",
	attendanceTicketTimePhraseSubtract: "کسر زمان {type}",
	attendanceTimeOpAdd: "افزودن زمان تیکت",
	attendanceTimeOpNone: "بدون تغییر در مانده زمان",
	attendanceTimeOpSubtract: "کسر زمان تیکت",
	attendanceTypeOptionAbsent: "غایب",
	attendanceTypeOptionBusinessTrip: "مأموریت / سفر کاری",
	attendanceTypeOptionHolidayNonWorking: "تعطیل / غیرکاری",
	attendanceTypeOptionJustifiedAbsence: "غیبت موجه (با عذر)",
	attendanceTypeOptionMaternity: "مرخصی زایمان",
	attendanceTypeOptionPaidVacation: "مرخصی استحقاقی",
	attendanceTypeOptionRemote: "دورکاری",
	attendanceTypeOptionSickLeave: "مرخصی استعلاجی",
	attendanceTypeOptionUnjustifiedAbsence: "غیبت غیرموجه (بدون عذر)",
	attendanceTypeOptionUnpaidLeave: "مرخصی بدون حقوق",
	attendanceTypeOptionWork: "کار",
	audio: "صوتی",
	autoDeletion: "حذف خودکار",
	averageDailyHours: "میانگین ساعات روزانه کاری",
	avgDaily: "ميانگين روزانه",
	avgDailyHours: "ميانگين ساعات روزانه",
	avgHoursPerWorkingDay: "ميانگين ساعات در هر روز کاري",
	avgOrderValue: "میانگین ارزش سفارش",
	avgResolutionTime: "میانگین زمان حل",
	avgResponseTime: "میانگین زمان پاسخ",
	avgTracksPerPlaylist: "میانگین قطعات/لیست پخش",
	back: "بازگشت",
	bank: "بانک",
	bankAccount: "حساب بانکی",
	bankCart: "کارت بانکی",
	bankEmitet: "بانک",
	banner: "بنر",
	baseSalary: "حقوق پایه",
	baseSalaryHourlyLinked: "نرخ ساعتی را از پایه ÷ ساعات عادی به‌روز می‌کند (وقتی ساعات > 0).",
	basicInformation: "اطلاعات پایه",
	beginningOfAcquaintance: "آغاز آشنایی",
	beginningOfContract: "آغاز قرارداد",
	beginningOfTraining: "آغاز آموزش",
	benefits: "مزایا",
	bestSeller: "پرفروش ترین",
	bestSellers: "پرفروش‌ترین‌ها",
	bestSellingItemsByRevenue: "پرفروش‌ترین اقلام بر اساس درآمد",
	bitrate: "نرخ بیت",
	biweekly: "دوماهه",
	blogItems: "آیتم‌های وبلاگ",
	blogs: "وبلاگ‌ها",
	bonuses: "پاداش‌ها",
	bpm: "BPM",
	branch: "شعبه شبکه برق",
	branches: "لیست شعب",
	branchesCitiesVillages: "شعب، شهرها، روستاها",
	brand: "برند",
	brands: "برندها",
	building: "ساختمان",
	businessTrip: "سفر کاری",
	buttonText: "متن دکمه",
	bypassSteps: "مرحله‌های کنار گذاشتن",
	calAddCalendarTooltip: "تقویم بسازید و با هم‌تیمی‌ها به‌اشتراک بگذارید",
	calAddEvent: "افزودن رویداد",
	calAddReminder: "افزودن یادآور",
	calAlarm15m: "۱۵ دقیقه قبل",
	calAlarm1d: "۱ روز قبل",
	calAlarm1h: "۱ ساعت قبل",
	calAlarm1w: "۱ هفته قبل",
	calAlarm2d: "۲ روز قبل",
	calAlarm2h: "۲ ساعت قبل",
	calAlarm30m: "۳۰ دقیقه قبل",
	calAlarm5m: "۵ دقیقه قبل",
	calAlarmAtEvent: "در زمان رویداد",
	calAllDay: "تمام روز",
	calApiNotConfigured: "API تقویم پیکربندی نشده است.",
	calCalendarColorLabel: "رنگ تقویم",
	calCalendarCreateFailed: "ایجاد تقویم ناموفق بود",
	calCalendarCreated: "تقویم ایجاد شد",
	calCalendarDeleted: "تقویم حذف شد",
	calCalendarNameLabel: "نام تقویم",
	calCalendarNamePh: "مثال: برنامه‌ریزی تیم",
	calCalendarNameRequired: "نام تقویم را وارد کنید",
	calCalendarSelect: "تقویم",
	calCalendarUpdateFailed: "به‌روزرسانی تقویم ناموفق بود",
	calCalendarUpdated: "تقویم به‌روزرسانی شد",
	calCalendarsLabel: "تقویم‌ها:",
	calGoogleCalendarLabel: "تقویم Google:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "جلسات:",
	calCancel: "لغو",
	calCheckAll: "انتخاب همه",
	calColor: "رنگ",
	calCreateCalendar: "ایجاد تقویم",
	calDay: "روز",
	calDayOverviewTitle: "روز",
	calDefaultCalendarName: "تقویم",
	calDelete: "حذف",
	calDeleteCalendarHasEvents: "این تقویم {count} رویداد دارد. چه می‌خواهید با آن‌ها انجام دهید؟",
	calDeleteCalendarNoEvents: "این عمل قابل بازگشت نیست.",
	calDeleteCalendarOnly: "فقط تقویم حذف شود",
	calDeleteCalendarTitle: "تقویم حذف شود؟",
	calDeleteCalendarWithEvents: "با رویدادها حذف شود",
	calDeleteEventText: "این عمل قابل بازگشت نیست.",
	calDeleteEventTitle: "رویداد حذف شود؟",
	calDeleteFailed: "حذف ناموفق",
	calDescription: "توضیحات",
	calDescriptionPh: "توضیح اختیاری",
	calEditCalendarTitle: "ویرایش تقویم",
	calEditCalendarTooltip: "ویرایش تقویم",
	calEditEvent: "ویرایش رویداد",
	calEditTooltip: "ویرایش",
	calEnd: "پایان",
	calEndBeforeStart: "پایان نمی‌تواند قبل از شروع باشد",
	calEndTime: "زمان پایان",
	calEvent: "رویداد",
	calEventCreated: "رویداد ایجاد شد",
	calEventDeleted: "رویداد حذف شد",
	calEventTitle: "عنوان",
	calEventTitlePh: "عنوان رویداد",
	calEventUpdated: "رویداد به‌روز شد",
	calEventsPlural: "رویداد",
	calExportIcs: "صادر کردن .ics",
	calFailedLoadEvents: "بارگذاری رویدادها ناموفق بود",
	calHrBirthdayEvent: "تولد",
	calHrBirthdays: "تولدها",
	calHrContractEnd: "پایان قرارداد",
	calHrContractEndEvent: "پایان قرارداد",
	calHrContractStart: "شروع قرارداد",
	calHrContractStartEvent: "شروع قرارداد",
	calHrIdEvent: "انقضای شناسنامه",
	calHrIdExpiry: "انقضای کارت ملی",
	calHrPassportEvent: "انقضای پاسپورت",
	calHrPassportExpiry: "انقضای پاسپورت",
	calHrPositionReview: "بازبینی سمت",
	calHrPositionReviewEvent: "بازبینی سمت",
	calHrSalaryReview: "بازبینی حقوق",
	calHrSalaryReviewEvent: "بازبینی حقوق",
	calImportButton: "وارد کردن",
	calImportEventsTitle: "وارد کردن رویدادها",
	calImportFoundInFile: "در فایل یافت شد. تقویم را برای وارد کردن انتخاب کنید:",
	calImportIcs: "وارد کردن .ics",
	calImportedEventTitle: "رویداد وارد شده",
	calItLabel: "فناوری اطلاعات:",
	calItWarrantyEnd: "پایان گارانتی",
	calItWarrantyEndEvent: "پایان گارانتی",
	calMonth: "ماه",
	calNewCalendarTitle: "تقویم جدید",
	calNewEvent: "رویداد جدید",
	calNoCalendar: "بدون تقویم",
	calNoCalendarUncategorised: "بدون تقویم (بدون دسته)",
	calNoEventsInIcs: "در فایل .ics رویدادی نیست",
	calNoEventsThisDay: "این روز رویدادی نیست.",
	calNoRemindersThisDay: "این روز یادآوری نیست.",
	calDayWeatherMap: "نقشه آب‌وهوا",
	calDayHourlyForecast: "پیش‌بینی ساعتی",
	calDayWeatherUnavailable: "پیش‌بینی برای این تاریخ در دسترس نیست",
	calDayEventsSection: "رویدادها",
	calDayRemindersSection: "یادآوری‌ها",
	calOpenProfile: "باز کردن پروفایل",
	calPeopleLabel: "افراد:",
	calReminders: "یادآورها",
	calRemindersLabel: "یادآورها:",
	calAttendanceLabel: "حضور:",
	calSecurityLabel: "امنیت:",
	calSecurityAlerts: "هشدارها",
	calSecuritySessions: "جلسات",
	calSecurityTokenExpiry: "انقضای توکن",
	calRemindersToggle: "یادآورهای فعال",
	calSave: "ذخیره",
	calSaveFailed: "ذخیره ناموفق",
	calShareWithUsers: "اشتراک‌گذاری با کاربران",
	calShareWithUsersPh: "جستجو و انتخاب افراد",
	calStart: "شروع",
	calStartEndRequired: "زمان شروع و پایان لازم است",
	calStartTime: "زمان شروع",
	calSwalDelete: "حذف",
	calTaskHigh: "بالا",
	calTaskLow: "کم",
	calTaskMedium: "متوسط",
	calTaskUrgent: "فوری",
	calTasksLabel: "وظایف:",
	calTicketsLabel: "تیکت‌ها:",
	calToday: "امروز",
	calUserFallback: "کاربر",
	calWeek: "هفته",
	calculatePayroll: "محاسبه حقوق و دستمزد",
	calculated: "محاسبه‌شده",
	calculations: "محاسبات",
	calendarEventType: "رویداد تقویم",
	calling: "تماس",
	cancel: "لغو",
	clearText: "پاک کردن متن",
	cancelAction: "لغو اقدام",
	cancelBack: "لغو بازگشت",
	cancelled: "لغو شده",
	cannotBeUndone: "این عمل قابل بازگشت نیست.",
	cannotPayOnline: "نمی توان به صورت آنلاین پرداخت کرد",
	cart: "کارمندان",
	categories: "دسته بندی ها",
	category: "دسته بندی",
	categoryPerformance: "عملکرد دسته‌بندی",
	certificate: "گواهینامه",
	certificateImages: "تصاویر گواهی",
	certificates: "گواهینامه‌ها",
	changedDate: "تاریخ تغییر",
	channel: "کانال",
	channelWritePermissionDescription: "فقط مدیران چت می توانند پیام بنویسند",
	channels: "کانال ها",
	charts: "نمودارها",
	chatActions: "اقدامات چت",
	chatActiveLabel: "فعال...",
	chatAddOption: "افزودن گزينه",
	chatAddUsers: "افزودن کاربران",
	chatAddedToGroupNotification: "به گفت‌وگوی گروهی اضافه شديد",
	chatAddedYouToGroup: "شما را اضافه کرد به",
	chatAudioCall: "تماس صوتي",
	chatBulkDeleteFailed: "حذف گروهي ناموفق بود.",
	chatBulkForwardFailed: "ارسال مجدد گروهي ناموفق بود.",
	chatCallMessage: "پيام تماس",
	chatChoosingEmoji: "در حال انتخاب ايموجي...",
	chatClickMapToChoosePoint: "براي انتخاب يک نقطه سفارشي روي نقشه کليک کنيد.",
	chatCoordinatesUnavailable: "مختصات در دسترس نيست",
	chatCopyCoordinates: "کپي مختصات",
	chatCopyCoordinatesFailed: "کپي مختصات ناموفق بود.",
	chatCreatePoll: "ايجاد نظرسنجي",
	chatCurrent: "فعلي",
	chatCurrentLocation: "موقعيت فعلي",
	chatDashboard: "داشبورد چت",
	chatDeleteFailed: "حذف ناموفق بود",
	chatDeleteForMeOnly: "فقط براي من حذف شود",
	chatDeleteForParticipants: "براي شرکت کنندگان هم حذف شود",
	chatDeleteLocation: "حذف موقعيت",
	chatDeleteSelectedMessagesDescription:
		"اين اقدام پيام هاي انتخاب شده را از نماي چت حذف مي کند. پيام هايي که با مجوز فعلي قابل حذف نيستند به عنوان ناموفق گزارش مي شوند.",
	chatDeleteSelectedMessagesTitle: "حذف پيام هاي انتخاب شده",
	chatDeletionPartialWarning:
		"اگر برخي پيام ها قبلا حذف شده باشند يا بررسي مجوزها شکست بخورد، نتيجه حذف ممکن است جزئي باشد.",
	chatDepartmentSaveFailed: "به روزرساني بخش ناموفق بود",
	chatDepartmentSaveFailedTryAgain: "لطفا دوباره براي به روزرساني بخش تلاش کنيد.",
	chatDeselectAllMessages: "لغو انتخاب همه",
	chatDestinationChatsLabel: "چت هاي مقصد",
	chatDestinationChatsPlaceholder: "يک يا چند چت را انتخاب کنيد",
	chatDirect: "چت مستقیم",
	chatDirectChat: "چت مستقيم",
	chatEditFailed: "ویرایش پیام انجام نشد",
	chatEditFailedTryAgain: "لطفا دوباره برای ویرایش تلاش کنید.",
	chatEditMessagePlaceholder: "پیام را ویرایش کنید...",
	writeMessage: "پیام بنویسید...",
	chatEditingMessage: "در حال ویرایش پیام",
	chatExitSelectionMode: "خروج از حالت انتخاب",
	chatExpired: "منقضي",
	chatForwardFailed: "ارسال مجدد ناموفق بود",
	chatForwardSelectedMessagesTitle: "ارسال مجدد پيام هاي انتخاب شده",
	chatForwardableLabel: "قابل ارسال مجدد",
	chatGeolocationUnavailable: "موقعيت جغرافيايي در اين مرورگر در دسترس نيست.",
	chatGroupChat: "گفت‌وگوی گروهی",
	chatGroupInfo: "اطلاعات گروه",
	chatGroupMembers: "اعضاي گروه",
	chatGroupSettings: "تنظيمات گروه",
	chatGroupSettingsDescription: "تصوير گروه و بخش منابع انساني مرتبط را تنظيم کنيد",
	chatID: "شناسه چت",
	chatImageUploadFailed: "آپلود تصوير ناموفق بود",
	chatImageUploadFailedTryAgain: "لطفا يک تصوير ديگر آپلود کنيد.",
	chatIncludeLabel: "شامل",
	chatIsChoosingEmoji: "در حال انتخاب ايموجي است...",
	chatIsTyping: "در حال نوشتن است...",
	chatLastUpdated: "اخرين به روزرساني",
	chatLatitude: "عرض جغرافيايي",
	chatLive: "زنده",
	chatLiveFor: "زنده براي",
	chatLiveLocation: "موقعيت زنده",
	chatLiveLocationOptInWarning: "موقعيت زنده نيازمند پذيرش صريح است و هر زمان قابل توقف است.",
	chatLiveLocationSharingActive: "اشتراک گذاري موقعيت زنده فعال است",
	chatLoadingLocation: "در حال بارگذاري موقعيت...",
	chatLoadingPoll: "در حال بارگذاري نظرسنجي...",
	chatLongitude: "طول جغرافيايي",
	chatMessagesCannotBeForwarded: "پيام(ها) قابل ارسال مجدد نيست و رد خواهد شد.",
	chatMessagesDeleted: "پيام ها حذف شدند",
	chatMessagesForwarded: "پيام ها ارسال مجدد شدند",
	chatMoreActions: "اقدامات بيشتر",
	chatNoAvailableUsersToAdd: "همه کاربران موجود از قبل در اين گروه هستند.",
	chatNoBackground: "بدون پس زمينه",
	chatNoChatsFound: "چتي يافت نشد",
	chatNoMessagesForwarded: "هيچ پيامي قابل ارسال مجدد نبود.",
	chatNoSelectedMessagesDeleted: "هيچ کدام از پيام هاي انتخاب شده حذف نشد.",
	chatOpenDepartmentPage: "باز کردن صفحه بخش",
	chatOpenMap: "باز کردن نقشه",
	chatOptionalAddressLabel: "برچسب آدرس اختياري",
	chatOwnMessagesLabel: "مال خودم",
	chatPartialDelete: "حذف جزئي",
	chatPartialForward: "ارسال مجدد جزئي",
	chatPattern: "الگو",
	chatPickOnMap: "انتخاب روي نقشه",
	chatPickPointOnMap: "يک نقطه روي نقشه انتخاب کنيد.",
	chatPinnedLocation: "موقعيت سنجاق شده",
	chatPollAddAnotherOption: "افزودن يک گزينه ديگر",
	chatPollAddOptionFailed: "افزودن گزينه ناموفق بود.",
	chatPollAllowAddingOptions: "اجازه افزودن گزينه",
	chatPollAllowMultipleAnswers: "اجازه پاسخ چندگانه",
	chatPollAllowRevote: "اجازه راي مجدد",
	chatPollAnonymous: "نظرسنجي ناشناس",
	chatPollAnonymousCannotAddOptions: "آزمون ناشناس نمي تواند افزودن گزينه را مجاز کند.",
	chatPollAtLeastOptions: "حداقل گزينه لازم است:",
	chatPollAutoClose: "بستن خودکار",
	chatPollChangeVote: "تغيير راي",
	chatPollChooseCorrectAnswer: "حداقل يک پاسخ صحيح براي آزمون انتخاب کنيد.",
	chatPollCloseDate: "تاريخ بستن",
	chatPollCloseDateOrOpenPeriod: "يا تاريخ بستن را استفاده کنيد يا بازه را، هر دو با هم نه.",
	chatPollCloseFailed: "بستن نظرسنجي ناموفق بود.",
	chatPollClosePoll: "بستن نظرسنجي",
	chatPollCorrectAnswer: "پاسخ صحيح",
	chatPollCorrectAnswers: "پاسخ هاي صحيح",
	chatPollCreateFailed: "ايجاد نظرسنجي ناموفق بود.",
	chatPollDeletePoll: "حذف نظرسنجي",
	chatPollDescriptionMax: "توضيح حداکثر بايد",
	chatPollExplanationMax: "توضيح بايد حداکثر",
	chatPollHideResultsUntilClosed: "پنهان کردن نتايج تا زمان بسته شدن",
	chatPollIncorrectAnswer: "پاسخ نادرست",
	chatPollLeaveEmptyKeepOpen: "براي باز ماندن نظرسنجي خالي بگذاريد",
	chatPollLeaveEmptyNoTimer: "براي بدون زمان سنج خالي بگذاريد",
	chatPollLoadVotersFailed: "بارگذاري راي دهندگان ناموفق بود.",
	chatPollMultipleChoice: "چند گزينه اي",
	chatPollNewOption: "گزينه جديد",
	chatPollNoVoteYet: "هنوز رايي ثبت نشده",
	chatPollNoVotersForOption: "راي دهنده اي براي اين گزينه يافت نشد.",
	chatPollOpenPeriod: "بازه باز بودن",
	chatPollOptionMax: "گزينه بايد حداکثر",
	chatPollOptionRequired: "گزينه الزامي است.",
	chatPollOptionsUnique: "گزينه ها بايد يکتا باشند.",
	chatPollPublic: "عمومي",
	chatPollQuestionMax: "سوال حداکثر بايد",
	chatPollQuestionRequired: "سوال الزامي است.",
	chatPollQuiz: "آزمون",
	chatPollQuizExplanation: "توضيح آزمون",
	chatPollRegular: "عادي",
	chatPollResultsHiddenUntilClosed: "نتايج تا زمان بسته شدن نظرسنجي مخفي است.",
	chatPollSearchVoters: "جستجوي راي دهندگان",
	chatPollShuffleOptions: "به هم زدن گزينه ها",
	chatPollSingleChoice: "تک انتخاب",
	chatPollSingleChoiceOneCorrect: "آزمون تک انتخابي فقط يک پاسخ صحيح مي تواند داشته باشد.",
	chatPollSubmitVoteFailed: "ارسال راي شما ناموفق بود.",
	chatPollViewVoters: "مشاهده راي دهندگان",
	chatPollVoteRecorded: "راي ثبت شد",
	chatPollVotersLabel: "راي دهنده",
	chatPollVotersTitle: "راي دهندگان نظرسنجي",
	chatPollYouVoted: "شما راي داديد.",
	chatPollYouVotedCanChange: "شما راي داده ايد و مي توانيد پاسخ خود را تغيير دهيد.",
	chatPreviewChronological: "پيش نمايش (زماني)",
	chatProvider: "ارائه دهنده",
	chatReadCurrentLocationFailed: "خواندن موقعيت فعلي شما ناموفق بود.",
	chatRefreshCurrentLocation: "به روزرساني موقعيت فعلي",
	chatRuleAllow: "بله",
	chatRuleDeny: "خیر",
	chatRuleTimed: "بله، اما فقط برای مدت محدود",
	chatRuleTimerDescription:
		"مثال: اگر 1 بگذارید، این عمل فقط در یک دقیقه اول بعد از ارسال مجاز است.",
	chatRuleTimerMinutes: "تایمر بر حسب دقیقه",
	chatSearchMessage: "جستجوي پيام",
	chatSelectAllMessages: "انتخاب همه",
	chatSelectDepartment: "بخش منابع انساني را انتخاب کنيد",
	chatSelectOrLoadLocationFirst: "ابتدا يک موقعيت را انتخاب يا بارگذاري کنيد.",
	chatSelectRepeatingBackground: "يک پس زمينه تکراري انتخاب کنيد",
	chatSelectUsersToAdd: "کاربران براي افزودن را انتخاب کنيد",
	chatSelectedLabel: "انتخاب شده",
	chatSelectionMode: "حالت انتخاب",
	chatSendCurrentLocation: "ارسال موقعيت فعلي",
	chatSendLocationFailed: "ارسال موقعيت ناموفق بود.",
	chatSendPinnedLocation: "ارسال موقعيت سنجاق شده",
	chatSendVenue: "ارسال مکان",
	chatSentAt: "ارسال شد",
	chatSettings: "تنظيمات چت",
	chatSettingsEditRule: "ویرایش پیام",
	chatSettingsEditRuleDescription:
		"مشخص کنید پیام های ارسال شده همیشه، هرگز یا فقط برای مدت محدودی قابل ویرایش باشند.",
	chatSettingsForwardRule: "فوروارد پیام",
	chatSettingsForwardRuleDescription:
		"فوروارد را همیشه، هرگز یا فقط تا مدت کوتاهی بعد از ارسال پیام اصلی مجاز کنید.",
	chatSettingsGlobalPageSubtitle:
		"قوانین چت های شخصی را یک بار اینجا تنظیم کنید. فقط مدیران گروه می توانند قوانین گروه را تغییر دهند.",
	chatSettingsGlobalPageTitle: "تنظیمات سراسری چت",
	chatSettingsGlobalRulesDescription:
		"این قوانین در همه چت های شخصی اعمال می شوند.",
	chatSettingsGlobalSavedSuccess: "تنظیمات سراسری چت با موفقیت به روز شد",
	chatSettingsCompactMode: "حالت فشرده",
	chatSettingsCompactModeDescription:
		"فاصله ها و اندازه تصویر نمایه را کاهش دهید تا چت های بیشتری در نوار کناری جا بگیرند.",
	chatSettingsSidebarDescription: "نحوه نمایش چت ها در نوار کناری سمت چپ را کنترل کنید.",
	chatSettingsSidebarTitle: "نوار کناری چت",
	chatSettingsShowLastMessage: "نمایش آخرین پیام",
	chatSettingsShowLastMessageDescription:
		"پیش نمایش آخرین پیام و تاریخ یا زمان آن را در نوار کناری چت نمایش دهید.",
	chatSettingsReplyRule: "پاسخ به پیام",
	chatSettingsReplyRuleDescription:
		"کنترل کنید اعضا همیشه، هرگز یا فقط در یک بازه زمانی بعد از ارسال بتوانند پاسخ دهند.",
	chatSettingsResetToGlobal: "بازگرداندن قوانین پیش فرض گروه",
	chatSettingsRulesAdminOnly: "فقط مدیران چت می توانند این قوانین را تغییر دهند.",
	chatSettingsRulesDescription:
		"تنظیم کنید اعضا بتوانند پیام را فوروارد، ریپلای یا ویرایش کنند و در صورت نیاز زمان بگذارید.",
	chatSettingsRulesTitle: "قوانین چت",
	chatSettingsSaveFailed: "ذخیره تنظیمات چت انجام نشد",
	chatSettingsSaveFailedTryAgain: "لطفا دوباره تلاش کنید.",
	chatSettingsUsingCustomRules:
		"این گروه از قوانین تعیین شده توسط مدیران استفاده می کند.",
	chatSettingsUsingGlobalRules: "این گروه از قوانین پیش فرض استفاده می کند.",
	chatShareLocation: "اشتراک گذاري موقعيت",
	chatSkipLabel: "رد کردن",
	chatSkippedLabel: "رد شده",
	chatStartCall: "شروع تماس",
	chatStartLiveSharing: "شروع اشتراک گذاري زنده",
	chatStopLiveSharing: "توقف اشتراک گذاري زنده",
	chatType: "نوع چت",
	chatTypeToSearch: "براي جستجو تايپ کنيد",
	chatTyping: "در حال نوشتن...",
	chatUnnamedChat: "چت بدون نام",
	chatUpdatingSharedLocationFor: "به روزرساني اين موقعيت اشتراکي براي",
	chatUploadGroupImage: "آپلود تصوير گروه",
	chatUserInfo: "اطلاعات کاربر",
	chatUsersSaveFailed: "افزودن کاربران ناموفق بود",
	chatUsersSaveFailedTryAgain: "لطفا دوباره براي افزودن کاربران انتخاب شده تلاش کنيد.",
	chatVenue: "مکان",
	chatVenueTitle: "عنوان مکان",
	chatVideoCall: "تماس ويديويي",
	chatViewReportedMessages: "مشاهده پيام هاي گزارش شده",
	chatWaitingDeviceCoordinates: "در انتظار مختصات دستگاه...",
	childcarePayment: "پرداخت نگهداری کودک",
	chooseBoard: "لوحة را انتخاب کنید تا فئات و مهمات آن را ببینید",
	cities: "شهرها",
	city: "شهر",
	clear: "پاک کردن",
	clearFilters: "پاک کردن فیلترها",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"برای برداشتن گام بعدی در سفر خود، روی دکمه زیر کلیک کنید",
	client: "مشتری",
	contactEngagement: "تعامل مشتریان",
	contactGroup: "گروه مشتریان",
	contactGroups: "گروه‌های مشتریان",
	contactPlaylist: "لیست پخش مشتری",
	contactProfile: "پروفایل مشتری",
	clients: "مشتریان",
	contactsByGender: "مشتریان بر اساس جنسیت",
	contactsByGroup: "مشتریان بر اساس گروه",
	contactsUsing: "مشتریان استفاده‌کننده",
	contactsWithCarts: "مشتریان با سبد خرید",
	contactsWithFavorites: "مشتریان با علاقه‌مندی‌ها",
	clockInOut: "ورود / خروج",
	close: "بستن",
	closeNavigation: "بستن ناوبری",
	closeTicket: "بستن تیکت",
	closed: "بسته",
	closed_late: "بسته شده بعد از مهلت",
	closedDate: "تاریخ بسته شدن",
	closedTickets: "بلیط‌های بسته شده",
	cmDashboard: "پیشخوان مدیریت محتوا",
	code: "کد",
	coin: "سکه",
	coinBurnTime: "زمان سوزاندن سکه",
	coinCount: "تعداد سکه",
	color: "رنگ",
	comment: "نظر",
	commentTicket: "نظر بلیت",
	commissions: "کمیسیون‌ها",
	communicationPreferences: "ترجیحات ارتباطی",
	community: "جامعه",
	company: "شرکت",
	completed: "تکمیل شد",
	completedDate: "تاریخ انجام",
	completedTasks: "وظایف تکمیل شده",
	completionRate: "نرخ تکمیل",
	confirm: "تأیید",
	confirmAction: "تأیید اقدام",
	contactForm: "فرم تماس",
	contactForms: "فرم‌های تماس",
	contactType: "نوع تماس",
	contacts: "مخاطبین",
	contentByType: "محتوا بر اساس نوع",
	contentItems: "آیتم‌های محتوا",
	contentManagementOverview: "نمای کلی سیستم مدیریت محتوا",
	contentOverTime: "محتوا ایجاد شده در طول زمان (30 روز گذشته)",
	continue: "ادامه",
	contract: "قرارداد",
	contractEndDate: "تاریخ پایان قرارداد",
	contractStartDate: "تاریخ شروع قرارداد",
	contractor: "پیمانکار",
	copy: "کپی",
	costOfBuildingPart: "هزینه بخش ساختمان",
	costOfBuildingPermit: "هزینه مجوز ساخت",
	country: "کشور",
	cpu: "پردازنده",
	create: "سفارش",
	createBoard: "ایجاد بورد جدید",
	createChat: "ایجاد چت",
	createGroupChat: "ایجاد چت گروهی",
	createGroupSubmit: "ایجاد",
	addNewCategory: "افزودن دسته جدید",
	createNewCategory: "ایجاد دسته جدید",
	created: "ایجاد شد",
	createdAt: "ایجاد شده در",
	createdBy: "ایجاد شده توسط",
	createdByUser: "ایجاد شده توسط کاربر",
	critical: "بحرانی",
	crmDashboard: "پیشخوان CRM",
	cta1: "تماس با بخش عملیات 1",
	cta2: "تماس با بخش عملیات 2",
	cta3: "تماس با بخش عملیات 3",
	currency: "ارز",
	currentlyStreaming: "در حال پخش",
	currentlyWorking: "در حال کار",
	custom: "سفارشی",
	customerAcquisition: "جذب مشتری",
	customerBaseOverview: "بررسی پایه مشتریان",
	customerInsights: "بینش مشتری",
	customerRelationshipOverview: "نمای کلی مدیریت روابط مشتریان",
	dashboard: "پانل مدیریت",
	dashboardSubtitle: "زیرعنوان داشبورد",
	database: "پایگاه داده",
	date: "تاریخ",
	dateOfBirth: "تاریخ تولد",
	dates: "تاریخ‌ها",
	datingAttendance: "حضور در قرار ملاقات‌ها",
	dayOff: "روز تعطیل",
	meeting: "جلسه",
	dayOffForAllEmployees: "تعطیل برای همه کارکنان",
	dayOffRemoved: "تعطیل حذف شد",
	dayOffSavedForAllEmployees: "تعطیل برای همه کارکنان ذخیره شد",
	days: "روز",
	daysLeft: "روز باقی مانده",
	daysOfWeek: "روزهای هفته",
	daysWorked: "روزهاي کاري",
	deadLine: "مهلت",
	deadline: "مهلت",
	debt: "بدهی",
	decline: "رد کردن",
	deductions: "کسور",
	defaultEnergyMax: "طاقة اکثرین افتراضی",
	defaultEnergyMin: "حداد سطح انرژی",
	defaultStream: "جریان پیش‌فرض",
	defaultStreams: "جریان‌های پیش‌فرض",
	defaultStreamsDesc: "جریان‌های پیش‌فرض",
	delays: "تاخیرها",
	delete: "حذف",
	deleteForEveryone: "حذف برای همه",
	deletePermanently: "حذف دائمی",
	deleteRule: "حذف قانون",
	deleteSelected: "حذف موارد انتخاب‌شده",
	delivery: "تحویل",
	deliveryAddress: "آدرس تحویل",
	deliveryMethod: "روش تحویل",
	density: "چگالی",
	department: "بخش",
	departmentChatsHelp:
		"چت‌های گروه و کانال را به این دپارتمان وصل کنید؛ با فیلد دپارتمان در هر چت همگام می‌ماند.",
	departmentLinkedChats: "گفتگوهای دپارتمان",
	departments: "بخش‌ها",
	desc: "توضیحات",
	description: "توضیحات",
	designer: "طراح",
	detailedFilters: "فیلترهای دقیق",
	detailedSteps: "مراحل دقیق",
	details: "جزئیات",
	developed: "توسعه یافته",
	developedBy: "توسعه یافته توسط",
	difference: "تفاوت",
	diplomaImages: "تصاویر دیپلم",
	directMessages: "پیام های مستقیم",
	disableSteps: "مراحل را غیرفعال کنید",
	disabledSteps: "مراحل غیرفعال",
	disk: "دیسک",
	distributionByPaymentType: "توزیع بر اساس نوع پرداخت",
	domainFacility: "تأسیسات",
	domainFinance: "مالی",
	domainHR: "HR",
	domainIT: "IT",
	domainOther: "دیگر",
	domainSecurity: "امنیت",
	done: "انجام شده",
	download: "دانلود",
	downloadAsContact: "دانلود به عنوان تماس",
	draft: "پیش‌نویس",
	dragToReorder: "برای دوباره مرتب کردن بکشید",
	dropFilesHere: "فایل ها را اینجا بکشید",
	dropFilesHereOrClick: "فایل ها را اینجا بکشید یا برای اضافه کردن بیشتر کلیک کنید",
	dropzoneText: "تصاویر را اینجا بکشید یا برای انتخاب فایل‌ها کلیک کنید",
	dueDate: "تاریخ موعد",
	duration: "مدت زمان",
	ecommerceDashboard: "پیشخوان تجارت الالکترونیکی",
	edit: "ویرایش",
	editComment: "ویرایش نظر",
	editItem: "ویرایش مورد",
	editProject: "ویرایش پروژه",
	editRule: "ویرایش قانون",
	edited: "ویرایش شده",
	editingRule: "ویرایش قانون",
	email: "ایمیل",
	sendEmail: "ارسال ایمیل",
	employee: "کارمزد",
	employeesPerDepartment: "کارمندان هر بخش",
	employerExpenses: "هزینه‌های کارفرما",
	employmentStatus: "وضعیت استخدام",
	emptyTrash: "حذف سل قرار خواهد گرفت",
	end: "پایان",
	endDate: "تاریخ پایان",
	endDateMustBeLaterThanStartDate: "تاریخ پایان باید بعد از تاریخ شروع باشد",
	endDateShort: "تاریخ پایان",
	endOfTraining: "پایان آموزش",
	endTime: "زمان پایان",
	ends: "پایان می‌یابد",
	energyLevel: "سطح انرژی",
	energyScheduling: "برنامه ریزی انرژی",
	enterAmount: "مبلغ را وارد کنید",
	enterFeatureSuffix: "متن سونیک خاصیت را وارد کنید",
	enterFeatureText: "متن خاصیت را وارد کنید",
	enterGroupName: "نام گروه را وارد کنید...",
	enterLabel: "برچسب را وارد کنید",
	enterPersons: "تعداد اشخاص را وارد کنید",
	enterRuleName: "نام قانون را وارد کنید",
	entry: "ورود",
	error: "خطا",
	errorMessage: "خطایی رخ داده است، لطفا دوباره تلاش کنید.",
	errorOccurred: "خطایی رخ داده است",
	errorPageButton: "مرا به خانه ببر",
	errorPageHelpText: "به کمک نیاز دارید؟ با تیم پشتیبانی ما تماس بگیرید",
	errorPageSecondaryButton: "گزارش این مشکل",
	errorPageSubtitle: "صفحه‌ای که دنبال آن می‌گردید وجود ندارد",
	errorPageText:
		"نگران نباشید، این برای بهترین‌های ما هم اتفاق می‌افتد! ممکن است صفحه منتقل شده، حذف شده باشد یا شما URL اشتباه وارد کرده باشید. بیایید شما را به مسیر درست برگردانیم.",
	errorPageTitle: "اوه! مشکلی پیش آمد",
	errorUserNotFound: "کاربر پیدا نشد",
	estimatedHours: "تقدير زمان",
	eventType: "نوع رویداد",
	exit: "خروج",
	expectedSalary: "حقوق مورد انتظار",
	expireDate: "تاریخ انقضا",
	expired: "منقضی شده است",
	expiresOn: "منقضی می شود",
	expiringIdCards: "کارت‌های شناسایی در حال انقضا",
	expiringPassports: "گذرنامه‌های در حال انقضا",
	export: "صادر کردن",
	exportData: "صادرات داده ها",
	extraLarge: "خیلی بزرگ",
	extraSmall: "خیلی کوچک",
	faqQuestions: "سوالات متداول",
	favorites: "مورد علاقه",
	features: "خصائص",
	female: "زن",
	fields: "فیلدها",
	file: "فایل",
	fileHasBeenRemoved: "فایل حذف شده است",
	fileMovedToTrash: "فایل به سل قرار خواهد گرفت",
	fileRestored: "بازیابی شده است",
	fileWillBeMovedToTrash: "فایل به سل قرار خواهد گرفت",
	files: "فایل‌ها",
	filesRestored: "بازیابی شده اند",
	filesWillBePermanentlyDeleted: "فایل برای همیشه حذف خواهند شد.",
	filter: "فیلتر",
	filterBy: "فیلتر",
	filters: "فیلترها",
	finish: "پایان",
	fired: "اخراج شده",
	firstIn: "اولین ورود",
	firstName: "نام",
	forgotPassword: "فراموش کرده‌اید رمز عبور را؟",
	forward: "ارسال",
	forwardMessage: "پیام را ارسال کنید",
	forwarded: "ارسال شده",
	forwardedFrom: "ارسال شده از",
	fri: "جمعه",
	from: "از",
	fromAttendanceLogs: "از سوابق حضور این کارمند و دوره پر می‌شود؛ قابل تغییر است.",
	fromDb: "از پایگاه داده",
	fromHrSettings: "تنظیمات منابع انسانی",
	gallery: "گالری",
	genderDistribution: "توزیع جنسیت",
	globalFilter: "فیلتر جهانی",
	globalSearchClose: "بستن",
	globalSearchCmd_goCalendar_desc: "رویدادهای تقویم",
	globalSearchCmd_goCalendar_label: "رفتن به تقویم",
	globalSearchCmd_goChat_desc: "باز کردن پیام‌رسانی",
	globalSearchCmd_goChat_label: "رفتن به چت",
	globalSearchCmd_goCrm_desc: "مدیریت مشتری",
	globalSearchCmd_goCrm_label: "رفتن به CRM",
	globalSearchCmd_goFinance_desc: "ماژول مالی",
	globalSearchCmd_goFinance_label: "رفتن به امور مالی",
	globalSearchCmd_goHr_desc: "ماژول منابع انسانی",
	globalSearchCmd_goHr_label: "رفتن به منابع انسانی",
	globalSearchCmd_goIt_desc: "تجهیزات فناوری اطلاعات",
	globalSearchCmd_goIt_label: "رفتن به فناوری اطلاعات",
	globalSearchCmd_goProjects_desc: "پایگاه داده پروژه‌ها",
	globalSearchCmd_goProjects_label: "رفتن به پروژه‌ها",
	globalSearchCmd_goRadio_desc: "موسیقی و لیست‌های پخش",
	globalSearchCmd_goRadio_label: "رفتن به رادیو",
	globalSearchCmd_goTickets_desc: "سیستم تیکت پشتیبانی",
	globalSearchCmd_goTickets_label: "رفتن به تیکت‌ها",
	globalSearchCmd_goTodo_desc: "بردها و وظایف",
	globalSearchCmd_goTodo_label: "رفتن به کارها",
	globalSearchCmd_messageUser_desc: "باز کردن چت برای ارسال پیام",
	globalSearchCmd_messageUser_label: "پیام به کاربر",
	globalSearchCmd_newContact_desc: "افزودن مشتری CRM",
	globalSearchCmd_newClient_label: "مشتری جدید",
	globalSearchCmd_newOrder_desc: "ایجاد سفارش",
	globalSearchCmd_newOrder_label: "سفارش جدید",
	globalSearchCmd_newProject_desc: "ایجاد پروژه",
	globalSearchCmd_newProject_label: "پروژه جدید",
	globalSearchCmd_newTask_desc: "ایجاد وظیفه",
	globalSearchCmd_newTask_label: "وظیفه جدید",
	globalSearchCmd_newTicket_desc: "ایجاد تیکت پشتیبانی",
	globalSearchCmd_newTicket_label: "تیکت جدید",
	globalSearchCommandBadge: "دستور",
	globalSearchCommands: "دستورات",
	globalSearchCopied: "کپی شد!",
	globalSearchCopyLink: "کپی لینک",
	globalSearchDirectMessage: "پیام مستقیم",
	globalSearchFilterAll: "همه",
	globalSearchFilterCalendar: "تقویم",
	globalSearchFilterChats: "چت‌ها",
	globalSearchFilterDevices: "دستگاه‌ها",
	globalSearchFilterEcom: "فروشگاه آنلاین",
	globalSearchFilterFinance: "مالی",
	globalSearchFilterPeople: "افراد",
	globalSearchFilterProjects: "پروژه‌ها",
	globalSearchFilterRadio: "رادیو",
	globalSearchFilterTickets: "تیکت‌ها",
	globalSearchFilterTodo: "کارها",
	globalSearchHidePreview: "پنهان کردن پیش‌نمایش",
	globalSearchNavigate: "پیمایش",
	globalSearchOpen: "باز کردن",
	globalSearchOpenInNewTab: "باز کردن در زبانه جدید",
	globalSearchPageBadge: "صفحه",
	globalSearchPlaceholder: "هر چیزی را در APIT جستجو کنید (کاربران، تیکت‌ها، چت‌ها، دستگاه‌ها…)",
	globalSearchPreviewAddress: "آدرس",
	globalSearchPreviewArtist: "هنرمند",
	globalSearchPreviewChat: "چت",
	globalSearchPreviewCompany: "شرکت",
	globalSearchPreviewCreated: "ایجاد شده",
	globalSearchPreviewDeviceId: "شناسه دستگاه",
	globalSearchPreviewEmail: "ایمیل",
	globalSearchPreviewEmployeeNumber: "شماره کارمند",
	globalSearchPreviewEnd: "پایان",
	globalSearchPreviewInfo: "اطلاعات",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "مکان",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "شماره",
	globalSearchPreviewOrderNumber: "شماره سفارش",
	globalSearchPreviewPhone: "تلفن",
	globalSearchPreviewSent: "ارسال",
	globalSearchPreviewStart: "شروع",
	globalSearchPreviewUsername: "نام کاربری",
	globalSearchPreviewVendor: "فروشنده",
	globalSearchPreviewVersion: "نسخه",
	globalSearchRecentSearches: "جستجوهای اخیر",
	globalSearchRecentlyOpened: "اخیراً باز شده",
	globalSearchSectionArtists: "هنرمندان",
	globalSearchSectionAttendanceDevices: "دستگاه حضور",
	globalSearchSectionBrands: "برندها",
	globalSearchSectionCalendarEvents: "رویدادهای تقویم",
	globalSearchSectionCameras: "دوربین‌ها",
	globalSearchSectionChats: "چت‌ها",
	globalSearchSectionClientGroups: "گروه‌های مشتری",
	globalSearchSectionClients: "مشتریان",
	globalSearchSectionCpus: "پردازنده‌ها",
	globalSearchSectionDepartments: "بخش‌ها",
	globalSearchSectionEcomCategories: "دسته‌ها",
	globalSearchSectionFinanceCardIssuers: "صادرکنندگان کارت",
	globalSearchSectionFinanceCards: "کارت‌ها",
	globalSearchSectionFinanceCategories: "دسته‌های مالی",
	globalSearchSectionFinanceTransactions: "تراکنش‌ها",
	globalSearchSectionGpus: "کارت گرافیک",
	globalSearchSectionKeyboards: "صفحه‌کلیدها",
	globalSearchSectionLaptops: "لپ‌تاپ‌ها",
	globalSearchSectionMessages: "پیام‌ها",
	globalSearchSectionMice: "موشواره‌ها",
	globalSearchSectionMonitors: "مانیتورها",
	globalSearchSectionOrders: "سفارش‌ها",
	globalSearchSectionPcs: "رایانه‌ها",
	globalSearchSectionPlaylists: "لیست‌های پخش",
	globalSearchSectionPositions: "سمت‌ها",
	globalSearchSectionPrinters: "چاپگرها",
	globalSearchSectionProblems: "مشکلات",
	globalSearchSectionProducts: "محصولات",
	globalSearchSectionProjects: "پروژه‌ها",
	globalSearchSectionRams: "رم",
	globalSearchSectionRoms: "حافظه",
	globalSearchSectionRooms: "اتاق‌ها",
	globalSearchSectionRouters: "مسیریاب‌ها",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "نرم‌افزار",
	globalSearchSectionSwitches: "سوئیچ‌ها",
	globalSearchSectionTelephones: "تلفن‌ها",
	globalSearchSectionTickets: "تیکت‌ها",
	globalSearchSectionTodoBoards: "بردها",
	globalSearchSectionTodoCategories: "دسته‌بندی‌ها",
	globalSearchSectionTodoTasks: "وظایف",
	globalSearchSectionTracks: "ترک‌ها",
	globalSearchSectionUsers: "افراد",
	globalSearchSectionWarrantyProviders: "ارائه‌دهندگان گارانتی",
	globalSearchSelectPreview: "یک مورد را برای پیش‌نمایش انتخاب کنید",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "نمایش پیش‌نمایش",
	globalSearchSubtitle: "جستجو در همه ماژول‌ها",
	globalSearchSuggest1: "جستجوی تیکت‌های محول‌شده به من",
	globalSearchSuggest2: "یافتن کارمند با ایمیل",
	globalSearchSuggest3: "جستجوی پیام‌های چت",
	globalSearchSuggest4: "یافتن دستگاه با IP",
	globalSearchSuggest5: "جستجوی مشتری با تلفن",
	globalSearchSuggest6: "رفتن به پروژه‌ها",
	globalSearchTrySearchingFor: "امتحان کنید",
	goBack: "بازگشت",
	goToMessage: "رفتن به پيام",
	goToUserAttendanceTab: "کاربران → حضور و غیاب",
	goToUserAttendanceTabTooltip: "باز کردن این کارمند در کاربران منابع انسانی با تب حضور و غیاب",
	gpu: "کارت گرافیک",
	grossSalary: "حقوق ناخالص",
	group: "گروه",
	groupChat: "چت گروهی",
	groupChatWritePermissionDescription: "همه اعضای چت می توانند پیام بنویسند",
	groupChats: "گروه چت ها",
	groupName: "نام گروه (اختیاری)",
	healthInsurance: "بیمه درمانی",
	healthInsuranceBenefit: "بیمه درمانی (مزیت)",
	help: "کمک",
	hideAllSteps: "پنهان کردن همه مراحل",
	hideHistory: "پنهان کردن تاریخ",
	hideProjectDetails: "مخفی کردن جزئیات پروژه",
	hideTableColumnFilters: "پنهان کردن فیلترهای ستون",
	hideTimeline: "پنهان کردن خط زمانی",
	high: "بالا",
	highestSpendingCustomers: "مشتریان با بیشترین هزینه",
	highlight: "مشترک",
	highlightFeature: "مشترک خاصیت",
	history: "تاریخچه",
	historyTable: "جدول تاریخچه",
	holiday: "تعطیل رسمی",
	holidayNonWorking: "تعطیل / روز غیرکاری",
	hourlyRate: "نرخ ساعتی",
	hourlyRateBaseLinked: "حقوق پایه را از نرخ ساعتی × ساعات عادی به‌روز می‌کند (وقتی ساعات > 0).",
	hr2025RateReferenceTables: "جداول مرجع نرخ ۲۰۲۵",
	hrAccrualAnnualTotal: "جمع سالانه: {amount} روز",
	hrAccrualDaily: "روزانه (÷ ۳۶۵)",
	hrAccrualEachDay: "هر روز: +{amount} روز مرخصی",
	hrAccrualEachMonthFirst: "هر روز اول ماه: +{amount} روز مرخصی",
	hrAccrualMethod: "روش تجمع",
	hrAccrualMethodDesc: "چگونه مرخصی تجمع می‌شود",
	hrAccrualMonthly: "ماهانه (÷ ۱۲، روز اول)",
	hrAccrualMonthlyEquivalent: "معادل ماهانه: ~{amount} روز",
	hrAccrualPreview: "پیش‌نمایش تجمع",
	hrArmeniaIncomeTaxCalculator: "ماشین‌حساب مالیات بر درآمد ارمنستان",
	hrArmeniaTaxRates: "نرخ‌های مالیاتی ارمنستان",
	hrCalcSummaryGrossToNet:
		"برای حقوق ثبت‌شده {gross} AMD، پس از کسر مالیات و کسور {deductions} AMD، مبلغ {net} AMD دریافت می‌کنید.",
	hrCalcSummaryNetToGross:
		"برای دریافت {net} AMD خالص، حقوق ناخالص در قرارداد باید {gross} AMD باشد.",
	hrCalculationBreakdown: "جزئیات محاسبه",
	hrCalculationDirection: "جهت محاسبه",
	hrDefaultBenefitsDescription:
		"این پیش‌فرض‌ها برای همه محاسبات حقوق اعمال می‌شوند مگر اینکه برای هر کارمند جایگزین شود.",
	hrDefaultMonthlyBenefits: "مزایای ماهانه پیش‌فرض (AMD)",
	hrDesiredNetSalaryLabel: "حقوق خالص مطلوب (مبلغ دریافتی)",
	hrEmployeePensionLabel: "بازنشستگی کارمند:",
	hrEmployeePensionRate: "نرخ بازنشستگی کارمند",
	hrEmployeePensionRateDesc: "اجباری برای متولدین پس از ۱۹۷۳ (۲٫۵٪)",
	hrEmployerPensionRate: "نرخ بازنشستگی کارفرما",
	hrEmployerPensionRateDesc: "سهم بازنشستگی کارفرما (۲٫۵٪)",
	hrFailedToSaveSettings: "ذخیره تنظیمات ناموفق بود",
	hrGrossSalaryAMD: "حقوق ناخالص (AMD)",
	hrGrossSalaryDescription: "مبلغ مندرج در قرارداد کار را وارد کنید",
	hrGrossSalaryLabel: "حقوق ناخالص (ثبت‌شده / مبلغ قرارداد)",
	hrGrossSalaryRegistered: "حقوق ناخالص (ثبت‌شده)",
	hrGrossToNet: "ناخالص → خالص",
	hrHealthInsuranceAges: "بیمه درمانی (سن ۱۸–۶۵)",
	hrHealthInsuranceBenefit: "بیمه درمانی",
	hrHealthInsuranceBenefitDesc: "سهم ماهانه کارفرما برای بیمه درمانی (AMD)",
	hrHealthInsuranceEmployeeColumn: "کارمند",
	hrHealthInsuranceEmployeeShare: "بیمه درمانی (سهم کارمند)",
	hrHealthInsuranceStateColumn: "دولت",
	hrITSector: "بخش فناوری اطلاعات (مالیات بر درآمد ۱۰٪)",
	hrITSectorDesc: "کارمند شرکت فناوری اطلاعات دارای مجوز",
	hrIncomeTax: "مالیات بر درآمد",
	hrIncomeTaxLabel: "مالیات بر درآمد:",
	hrIncomeTaxRate: "نرخ مالیات بر درآمد",
	hrIncomeTaxRateDesc: "نرخ ثابت ۲۰٪ در ارمنستان از ۲۰۲۰",
	hrLeaveAccrualConfiguration: "پیکربندی تجمع مرخصی",
	hrLiveRates: "نرخ‌های زنده",
	hrLunchCoverage: "پوشش ناهار",
	hrLunchCoverageDesc: "کمک هزینه ناهار/غذا ماهانه (AMD)",
	hrMandatoryHealthInsurance: "بیمه درمانی اجباری (۱۸–۶۵)",
	hrMandatoryHealthInsuranceDesc: "شامل پلکان بیمه درمانی ۲۰۲۵",
	hrMilitaryStampRate: "نرخ تمبر نظامی",
	hrMilitaryStampRateDesc: "در صورت عدم کاربرد ۰ بگذارید",
	hrMonthlyFee: "هزینه ماهانه",
	hrNetSalaryDescription: "مبلغی که می‌خواهید دریافت کنید را وارد کنید",
	hrNetSalaryLabel: "حقوق خالص:",
	hrNetSalaryTakeHome: "حقوق خالص (دریافتی)",
	hrNetToGross: "خالص → ناخالص",
	hrOvertimeRateMultiplier: "ضریب نرخ اضافه‌کاری",
	hrOvertimeRateMultiplierDesc: "مثلاً ۱٫۵× یعنی ۵۰٪ اضافه‌پرداخت اضافه‌کاری",
	hrOvertimeRules: "قوانین اضافه‌کاری",
	hrBreakIntervals: "بازه‌های استراحت",
	hrBreakIntervalsDesc:
		"بازه‌های زمانی ثابت روزانه (مانند ناهار) که برای همه از ساعات کاری مستثنی می‌شوند. می‌توانید بیش از یکی اضافه کنید.",
	hrBreakIntervalsEmpty: "هیچ بازه استراحتی تنظیم نشده است",
	hrBreakIntervalStart: "شروع استراحت",
	hrBreakIntervalEnd: "پایان استراحت",
	hrAddBreakInterval: "افزودن استراحت",
	hrOvertimeThreshold: "آستانه اضافه‌کاری (ساعت/روز)",
	hrOvertimeThresholdDesc: "ساعات بیش از این با نرخ اضافه‌کاری محاسبه می‌شود",
	hrPensionMandatory: "اجباری / داوطلبانه پیش از ۰۷/۲۰۱۸ (۵٪)",
	hrPensionNone: "غیرمشارکت‌کننده (۰٪)",
	hrPensionPost2018: "داوطلبانه پس از ۰۷/۲۰۱۸ (۵٪)",
	hrPensionSystem: "سیستم بازنشستگی",
	hrPensionSystemDesc: "وضعیت مشارکت شما در بازنشستگی تأمین‌شده",
	hrSettingsPageSubtitle: "حقوق و دستمزد، مرخصی و قوانین حضور را پیکربندی کنید",
	hrSettingsPageTitle: "تنظیمات منابع انسانی",
	hrSettingsUpdatedSuccessfully: "تنظیمات منابع انسانی با موفقیت به‌روزرسانی شد",
	hrSickDaysPerYear: "روزهای مرخصی استعلاجی در سال",
	hrSickDaysPerYearDesc: "روزهای مرخصی استعلاجی با حقوق در سال تقویمی",
	hrSocialPaymentPension: "پرداخت اجتماعی (بازنشستگی)",
	hrSocialTaxRate: "نرخ مالیات اجتماعی",
	hrSocialTaxRateDesc: "اکنون در ارمنستان ۰٪ (جایگزین شده با بازنشستگی)",
	hrStampFee: "تمبر (صندوق بیمه نظامی)",
	hrStampFeeTooltip: "صندوق بیمه نظامی — هزینه ثابت پلکانی بر اساس بازه حقوق ناخالص",
	hrStandardWorkSchedule: "برنامه کاری استاندارد",
	hrStateHealthContribution: "سهم دولت در بهداشت",
	hrStateHealthContributionNote:
		"توسط دولت به بسته بیماری شما افزوده می‌شود (از حقوق کسر نمی‌شود).",
	hrSuffixDays: "روز",
	hrSuffixHours: "ساعت",
	hrSuffixTimes: "×",
	hrSummary: "خلاصه",
	hrTabDefaultBenefits: "مزایای پیش‌فرض",
	hrTabLeaveAccrual: "تجمع مرخصی",
	hrTabTaxCalculator: "ماشین‌حساب مالیاتی",
	hrTabTaxesArmenia: "مالیات (ارمنستان)",
	hrTabWorkSchedule: "برنامه کاری",
	hrTaxPreviewTitle: "پیش‌نمایش مالیات (بر ۵۰۰٫۰۰۰ AMD ناخالص)",
	hrTaxRatesDescription:
		"نرخ‌ها به حقوق ناخالص اعمال می‌شوند. به صورت درصد وارد کنید (مثلاً ۲۰ = ۲۰٪).",
	hrTaxRatesDisclaimer:
		"نرخ‌ها بر اساس قوانین ارمنستان ۲۰۲۵–۲۰۲۶. مالیات بر درآمد: ۲۰٪ استاندارد، ۱۰٪ برای شرکت‌های فناوری دارای مجوز. بازنشستگی: ۵٪ (اجباری/داوطلبانه پیش از ۲۰۱۸) یا ۵٪ ثابت (داوطلبانه پس از ۲۰۱۸). نرخ اضافی ۱۰٪ برای مشارکت‌کنندگان اجباری/پیش از ۲۰۱۸ با درآمد بالای ۵۰۰٫۰۰۰ AMD. با حسابدار رسمی تأیید کنید.",
	hrThresholdWarning: "هشدار آستانه",
	hrThresholdWarningText:
		"حقوق شما نزدیک مرز پلکان است (۱۰۰k / ۲۰۰k / ۵۰۰k / ۱M AMD). در این نقاط تمبر و بیمه به پلکان بالاتر می‌رود؛ افزایش کوچک ناخالص ممکن است خالص را کم کند. ماشین‌حساب حداقل ناخالص لازم برای خالص درخواستی را نشان می‌دهد.",
	hrTickets: "تذکره‌های HR",
	hrTotalDeductions: "جمع کسور",
	hrTotalEmployeeDeductionsLabel: "جمع کسور کارمند:",
	hrTransportAllowance: "کمک هزینه حمل‌ونقل",
	hrTransportAllowanceDesc: "مزیت حمل‌ونقل ماهانه (AMD)",
	hrVacationDaysPerYear: "روزهای مرخصی سالانه",
	hrVacationDaysPerYearDesc: "سهم سالانه کامل (حداقل ارمنستان: ۲۰)",
	hrWorkingDayEnd: "پایان روز کاری",
	hrWorkingDayEndDesc: "پایان مورد انتظار شیفت. ساعات روزانه از زمان شروع/پایان محاسبه می‌شود",
	hrWorkingDayStart: "شروع روز کاری",
	hrWorkingDayStartDesc: "زمان ورود مورد انتظار برای حضور و بررسی تاخیر",
	hrWeekendDays: "روزهای آخر هفته",
	hrWeekendDaysDesc: "روزهای هفته‌ای را که تعطیل غیرکاری محسوب می‌شوند انتخاب کنید",
	hrWorkingDaysPerWeek: "روزهای کاری در هفته",
	hrWorkingDaysPerWeekDesc: "دوشنبه–جمعه = ۵، دوشنبه–شنبه = ۶",
	hrWorkingHoursPerDay: "ساعات کاری در روز",
	hrWorkingHoursPerDayDesc: "ساعات استاندارد قبل از اضافه‌کاری",
	href: "لینک",
	humanResources: "منابع انسانی",
	id: "شناسه",
	idCard: "کارت شناسایی",
	idCardEndDate: "تاریخ پایان کارت شناسایی",
	idCardNo: "شماره کارت شناسایی",
	idCardStartDate: "تاریخ شروع کارت شناسایی",
	idCart: "کارت شناسایی",
	image: "تصویر",
	immediateSupervisor: "سرپرست مستقیم",
	importance: "اهمیت",
	important: "مهم",
	inProgress: "در حال انجام",
	inSelectedPeriod: "در دوره انتخاب شده",
	inStock: "موجود",
	in_progress: "در حال انجام",
	inactive: "غیرفعال",
	inactiveTime: "زمان غیرفعال",
	incident: "رویداد",
	incomeTaxAmount: "مبلغ مالیات بر درآمد",
	incomeTaxRate: "نرخ مالیات بر درآمد (٪)",
	incomingCall: "تماس ورودی",
	incomingVideoCall: "تماس تصویری ورودی",
	incorrectLogin: "نام کاربری یا رمز عبور اشتباهی وارد کردید",
	index: "#",
	inputInArmenian: "ورود به ارمنی",
	inputInLatin: "ورود به لاتین",
	inputInNumbers: "ورودی به اعداد",
	inputInRussian: "ورود به روسی",
	inputNumber: "ورود شماره",
	inputNumbers: "عدد وارد کنید",
	instagramPosts: "پست‌های اینستاگرام",
	insufficientVacationBalance: "موجودی تعطیلات کافی نیست",
	interview1: "مصاحبه",
	interview2: "آشنایی",
	interview3: "آموزش",
	interview4: "کارآموزی",
	interviewDate: "تاریخ مصاحبه",
	interviewTime: "زمان مصاحبه",
	introSection: "بخش مقدمه",
	invalidDate: "تاریخ تحویل غیرمعتبر",
	inventorySummary: "خلاصه موجودی",
	ip: "IP",
	ipAddress: "آدرس IP",
	isActive: "فعال",
	isColor: "رنگ",
	isPrivateOffice: "آیا محل کاری خصوصی است",
	isPublic: "عمومی",
	itTickets: "تذکره‌های IT",
	items: "آیتم‌ها",
	justifiedAbsence: "غیبت موجه",
	keyText: "متن کلیدی",
	keyboards: "صفحه‌کلید",
	label: "برچسب",
	language: "زبان",
	languagePickerLabel: "زبان",
	large: "بزرگ",
	last7Days: "ورود در 7 روز گذشته",
	lastAction: "آخرین اقدام",
	lastLogin: "آخرین ورود",
	lastName: "نام خانوادگی",
	lastOut: "آخرین خروج",
	lastPunch: "آخرين ثبت حضور",
	lasts: "مدت",
	latestCustomerOrders: "آخرین سفارش‌های مشتری",
	leader: "رهبر",
	attendanceManagersFilter: "مدیران",
	attendanceLeadersFilter: "رهبران",
	leaveBalance: "موجودی مرخصی",
	linkCopied: "لینک کپی شد",
	listeners: "شنوندگان",
	livingAddress: "آدرس محل زندگی",
	loading: "در حال بارگذاری",
	loanDeductions: "کسور وام",
	localCode: "کد محلی",
	logOut: "خروج",
	login: "ورود",
	loginButton: "ورود",
	loginFailed: "ورود ناموفق",
	loginFailedMessage: "لطفاً اطلاعات ورود خود را بررسی کنید",
	loginSuccess: "ورود موفقیت‌آمیز",
	loginSuccessMessage: "با موفقیت وارد شدید",
	loginToStartSession: "وارد شوید تا جلسه آغاز شود",
	logout: "خروج",
	low: "کم",
	lunchCoverage: "پوشش ناهار",
	mac: "MAC",
	macAddress: "آدرس MAC",
	main: "اصلی",
	itHierarchyAddLaptop: "افزودن لپ‌تاپ",
	itHierarchyAttachedPc: "رایانه متصل",
	itHierarchyLaptopsUsingPart: "لپ‌تاپ‌هایی که از این قطعه استفاده می‌کنند",
	itUsedInOtherPlaces: "استفاده‌شده در مکان‌های دیگر",
	mainInformation: "اطلاعات پایه",
	mainInfo: "اطلاعات اصلی",
	contactInfo: "اطلاعات تماس",
	personalInfo: "اطلاعات شخصی",
	workingInfo: "اطلاعات کاری",
	probation: "دوره آزمایشی",
	educationInfo: "اطلاعات تحصیلی",
	male: "مرد",
	manualAdjustments: "تنظیمات دستی",
	manualAttendanceEntry: "ورود دستی",
	maps: "نقشه‌ها",
	maritalStatus: "وضعیت تاهل",
	markAllAsRead: "علامت‌گذاری همه به‌عنوان خوانده‌شده",
	markSelectedAsRead: "علامت‌گذاری انتخاب‌شده به‌عنوان خوانده‌شده",
	maternityLeave: "مرخصی زایمان",
	maxEnergy: "حداد سطح انرژی",
	maxFilesReached: "حداکثر تعداد فایل ها به دست آمده است",
	maxSize: "حداکثر اندازه",
	mediaGallery: "گالری رسانه",
	mediaGalleryDescription: "توضیحات گالری رسانه",
	mediator: "واسطه",
	medium: "متوسط",
	members: "اعضاء",
	menu: "منو",
	message: "پیام",
	messages: "پیام‌ها",
	messagesByType: "پیام‌ها بر اساس نوع",
	messagesOverTime: "پیام‌ها در طول زمان (30 روز گذشته)",
	militaryStampAmount: "مبلغ تمبر نظامی",
	militaryStampRate: "نرخ تمبر نظامی",
	minEnergy: "حداد سطح انرژی",
	minute: "دقیقه",
	minutes: "دقیقه",
	missingInterval: "بازه زمانی ناقص",
	mon: "دوشنبه",
	monitor: "مانیتور",
	monitors: "مانیتورها",
	month: "ماه",
	monthly: "ماهانه",
	mood: "حالت",
	more: "اضافی",
	moreDetailed: "بیشتر توضیح داده شده",
	moreThan: "بیشتر از",
	motherProject: "پروژه مادر",
	mounted: "نصب شده",
	mouses: "ماوس‌ها",
	moveToTrash: "حرکت به سل قرار خواهد گرفت",
	movedToTrash: "حرکت به سل قرار خواهد گرفت",
	myActiveSteps: "مراحل فعال من",
	myInvolvement: "درگیری من",
	myProjects: "پروژه‌های من",
	myRole: "نقش من",
	mySteps: "مراحل من",
	myTickets: "تذکره‌های من",
	na: "موجود نیست",
	name: "نام",
	netCash: "خالص نقدی",
	netOfficial: "خالص رسمی",
	netSalary: "حقوق خالص",
	newClients: "مشتریان جدید",
	newClientsOverTime: "مشتریان جدید در طول زمان (30 روز گذشته)",
	newMessage: "پیام جدید",
	newProducts: "محصولات جدید",
	newProject: "پروژه جدید",
	newProjects: "پروژه‌های جدید",
	newThisPeriod: "جدید در این دوره",
	newTicket: "بلیت جدید",
	newTicketCreatedBy: "بلیت جدید توسط ایجاد شده است",
	newTracks: "قطعات جدید",
	newTracksOverTime: "قطعات جدید در طول زمان (30 روز گذشته)",
	next: "بعدی",
	nextComposition: "ترکیب بعدی",
	nextStep: "مرحله بعدی",
	noAccess: "دسترسی وجود ندارد",
	noActiveSteps: "هیچ مرحله فعالی وجود ندارد",
	noBoardsFound: "بورد ها یافت نشد",
	noCategoriesFound: "دسته ها یافت نشد",
	noCategoryDataAvailable: "داده دسته‌بندی موجود نیست",
	noContent: "محتوایی وجود ندارد",
	noCustomerDataAvailable: "داده مشتری موجود نیست",
	noData: "هیچ داده‌ای موجود نیست",
	noDataAvailable: "هیچ داده ای در دسترس نیست",
	noDataAvailableForSelectedPeriod: "داده‌ای برای دوره انتخاب شده موجود نیست",
	noDepartment: "هیچ دپارتمانی وجود ندارد",
	noDepartments: "هیچ دپارتمانی وجود ندارد",
	noDescription: "توضیحات غیر موجود",
	noEmail: "ایمیل ندارد",
	noExpiringIdCards: "هیچ کارت شناسایی منقضی نمی شود",
	noExpiringPassports: "هیچ گذرنامه ای منقضی نمی شود",
	noGroup: "بدون گروه",
	noMediaDescription: "توضیحات رسانه یافت نشد",
	noMediaFound: "رسانه ای یافت نشد",
	noMoreItems: "هیچ آیتم دیگری نیست",
	noName: "بدون نام",
	noNeedStep45: "نیازی به مرحله 4-5 نیست",
	noNotifications: "اعلانی نیست",
	noOrdersInSelectedPeriod: "سفارشی در دوره انتخاب شده وجود ندارد",
	noOvertimeRecords: "سابقه اضافه کاری یافت نشد",
	noPaymentDataAvailable: "داده پرداختی موجود نیست",
	noProjectsAssigned: "هیچ پروژه‌ای اختصاص داده نشده است",
	noProjectsAssignedOrInvolved: "هیچ پروژه ای اختصاص داده نشده یا درگیر نیست",
	noRecentContacts: "مشتری اخیری وجود ندارد",
	noRecentContent: "محتواهای اخیری وجود ندارد",
	noRecentTickets: "بلیط اخیری وجود ندارد",
	noRecentTracks: "قطعه اخیری وجود ندارد",
	noRecipientInformation: "هیچ اطلاعات گیرنده ای وجود ندارد",
	noResponsible: "هیچ مسئولیتی ندارد",
	noResult: "نتیجه ای یافت نشد",
	noResults: "نتیجه ای یافت نشد",
	noResultsFound: "نتایجی یافت نشد",
	noRulesAdded: "قوانین برنامه ریزی هنگامی که هیچ قانونی اضافه نشده است",
	noStatusData: "داده وضعیتی موجود نیست",
	noSystemDaysOffThisMonth: "در این ماه تعطیل عمومی در سامانه نیست",
	noTaskDataAvailable: "هیچ داده‌ای برای کار موجود نیست",
	noTasksYet: "کارها هنوز وجود ندارند",
	noTasksYetDescription: "کارها هنوز وجود ندارند",
	noUpcomingBirthdays: "هیچ زادروزی در پیش نیست",
	noUsersFound: "کاربری یافت نشد",
	noUsersInDepartment: "هیچ کاربری در این بخش وجود ندارد",
	noWorkHourData: "هیچ داده ای از ساعت کاری وجود ندارد",
	no_priority: "بدون اولویت",
	nonWorking: "روز غیرکاری",
	none: "هیچ",
	notAvailable: "محصول در دسترس نیست",
	notCorrectLoginCredentials: "اطلاعات ورود نادرست است",
	notLoggedInToday: "امروز وارد نشده است",
	notPlaced: "قرار داده نشده",
	notPresent: "غایب",
	notResponded: "پاسخ داده نشده",
	notWorking: "فعال نیست",
	deviceProblems: "مشکلات دستگاه‌ها",
	openTickets: "تیکت‌های باز",
	note: "یادداشت",
	nothingFound: "چیزی یافت نشد",
	notifications: "اطلاعات",
	notificationsBellAria: "باز کردن اعلان‌ها",
	similarTicketNotifications: "اعلان‌های تیکت‌های مشابه",
	number: "عدد",
	"office-map": "نقشه دفتر",
	officeMapActivatePlacement: "فعال‌کردن جانمایی",
	officeMapAgent: "ایجنت",
	officeMapAll: "همه",
	officeMapAttendanceDevice: "دستگاه حضور و غیاب",
	officeMapAttendanceDevices: "حضور و غیاب",
	officeMapCable: "کابل",
	officeMapCableLinePlaced: "خط کابل جانمایی شد",
	officeMapCableRemovedFromMap: "کابل از نقشه حذف شد",
	officeMapCables: "کابل‌ها",
	officeMapCamera: "دوربین",
	officeMapCameras: "دوربین‌ها",
	officeMapNvr: "ضبط‌کننده ویدیوی شبکه (NVR)",
	officeMapChat: "چت",
	officeMapChatWasNotCreated: "چت ایجاد نشد",
	officeMapConnectToCamera: "اتصال به دوربین",
	officeMapCpu: "CPU",
	officeMapDeactivate: "غیرفعال‌کردن",
	officeMapDeviceDetails: "جزئیات دستگاه",
	officeMapDeviceId: "شناسه دستگاه",
	officeMapDisableDragging: "غیرفعال‌کردن جابه‌جایی",
	officeMapEnableDragging: "فعال‌کردن جابه‌جایی",
	officeMapEndDeviceOptional: "دستگاه پایان (اختیاری)",
	officeMapFailedToMoveCable: "جابجایی کابل انجام نشد",
	officeMapFailedToMoveItem: "جابجایی مورد انجام نشد",
	officeMapFailedToMoveRoomArea: "جابجایی ناحیه اتاق انجام نشد",
	officeMapFailedToOpenChat: "بازکردن چت انجام نشد",
	officeMapFailedToPlaceItem: "جانمایی مورد انجام نشد",
	officeMapFailedToPlaceUser: "جانمایی کاربر انجام نشد",
	officeMapFailedToRemoveCable: "حذف کابل انجام نشد",
	officeMapFailedToRemoveItem: "حذف مورد انجام نشد",
	officeMapFailedToRemoveRoomArea: "حذف ناحیه اتاق انجام نشد",
	officeMapFailedToSaveCableLine: "ذخیره خط کابل انجام نشد",
	officeMapFailedToSaveRoomArea: "ذخیره ناحیه اتاق انجام نشد",
	officeMapFinishArea: "پایان ناحیه",
	officeMapFinishCable: "پایان کابل",
	officeMapForbidden: "ممنوع",
	officeMapIp: "IP",
	officeMapItem: "مورد",
	officeMapItemPlaced: "مورد جانمایی شد",
	officeMapItemRemovedFromMap: "مورد از نقشه حذف شد",
	officeMapLaptop: "لپ‌تاپ",
	officeMapLaptops: "لپ‌تاپ‌ها",
	officeMapLayers: "لایه‌ها",
	officeMapLinkedItRoom: "اتاق IT مرتبط",
	officeMapLive: "زنده",
	officeMapMac: "MAC",
	officeMapMin: "حداقل",
	officeMapMonitors: "مانیتورها",
	officeMapNetworkCable: "کابل شبکه",
	officeMapNoDevicesInArea: "هیچ دستگاه یا کاربری در این ناحیه قرار نگرفته است.",
	officeMapNoPermissionToPlaceItem: "شما اجازه جانمایی این مورد را ندارید.",
	officeMapNoPermissionToPlaceNetworkCable: "شما اجازه جانمایی کابل شبکه را ندارید.",
	officeMapNoPermissionToPlaceRoomArea: "شما اجازه جانمایی ناحیه اتاق را ندارید.",
	officeMapNoPermissionToRemoveItem: "شما اجازه حذف این مورد از نقشه را ندارید.",
	officeMapNoPermissionToRemoveNetworkCable: "شما اجازه حذف کابل شبکه از نقشه را ندارید.",
	officeMapNoPermissionToRemoveRoomArea: "شما اجازه حذف ناحیه اتاق از نقشه را ندارید.",
	officeMapNotAvailable: "موجود نیست",
	officeMapNotConnected: "متصل نیست",
	officeMapPc: "رایانه",
	officeMapPcs: "رایانه‌ها",
	officeMapPlacement: "جانمایی",
	officeMapPleaseSelectItemFirst: "لطفاً ابتدا یک مورد انتخاب کنید",
	officeMapPleaseSelectRoomFirst: "لطفاً ابتدا یک اتاق انتخاب کنید",
	officeMapPoints: "نقاط",
	officeMapPorts: "پورت‌ها",
	officeMapPrinted: "چاپ‌شده",
	officeMapPrinters: "چاپگرها",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "حذف از نقشه",
	officeMapRom: "ROM",
	officeMapRoomArea: "ناحیه اتاق",
	officeMapRoomAreaPlaced: "ناحیه اتاق جانمایی شد",
	officeMapRoomAreaRemovedFromMap: "ناحیه اتاق از نقشه حذف شد",
	officeMapRoomAreas: "اتاق‌ها",
	officeMapRoomContents: "محتوای اتاق",
	officeMapRouter: "روتر",
	officeMapRouters: "روترها",
	officeMapSelectItem: "مورد را انتخاب کنید",
	officeMapSelectRoom: "اتاق را انتخاب کنید",
	officeMapSpeed: "سرعت",
	officeMapStartDeviceOptional: "دستگاه شروع (اختیاری)",
	officeMapSwitches: "سوئیچ‌ها",
	officeMapTelephone: "تلفن",
	officeMapTelephones: "تلفن‌ها",
	officeMapUnknown: "نامشخص",
	officeMapUrl: "نشانی",
	officeMapUserPlacedOnMap: "کاربر روی نقشه جانمایی شد",
	officeMapUsers: "کاربران",
	officeMapViewContents: "مشاهده محتوا",
	officeMapViewFullDetails: "مشاهده جزئیات کامل",
	offline: "آفلاین",
	offlinePaymentOnly: "فقط پرداخت آفلاین",
	oldProject: "پروژه قدیمی",
	onSale: "در حال فروش",
	onSecond: "در ثانیه",
	onTime: "به موقع",
	onTimeRate: "نرخ به موقع بودن",
	oneOf: "یکی از",
	open: "باز کردن",
	openBoard: "باز کردن کانبان",
	openDate: "تاریخ باز شدن",
	openInModal: "در پنجره مدال باز کن",
	openInNewTab: "در یک زبانه جدید باز کن",
	openNavigation: "باز کردن ناوبری",
	openedDate: "تاریخ باز شدن",
	optional: "اختیاری",
	orClickToSelect: "یا کلیک کنید تا فایل ها را انتخاب کنید",
	order: "سفارش",
	orderNumber: "شماره سفارش",
	orders: "سفارش‌ها",
	ordersCart: "نمودار سفارشات",
	otAfterWork: "اضافه کاری بعد از کار",
	otBeforeWork: "اضافه کاری قبل از کار",
	otherBenefits: "سایر مزایا",
	otherDeductions: "سایر کسور",
	otherInsurance: "سایر بیمه‌ها",
	outOfStock: "تمام شده",
	overdue: "دیرکرد",
	overtimeComment: "نظر اضافه کاری",
	overtimeDays: "روزهای اضافه‌کاری",
	overtimeHours: "ساعات اضافه‌کاری",
	overtimeRate: "نرخ اضافه‌کاری",
	overtimeSummary: "خلاصه اضافه‌کاری",
	overtimeTotal: "جمع اضافه‌کاری",
	overview: "بررسی",
	owner: "مالک",
	ownership: "مالکیت",
	pageNotFound: "صفحه یافت نشد",
	pageNotFoundDescription:
		"اوه! صفحه‌ای که به دنبال آن هستید وجود ندارد یا جابجا شده است. ممکن است حذف شده، نام آن تغییر کرده یا موقتاً در دسترس نباشد.",
	pages: "صفحات",
	paid: "پرداخت شده",
	paidStatus: "وضعیت پرداخت",
	paidTimeOff: "مرخصی با حقوق",
	paidTimeOffDays: "روزهای مرخصی با حقوق",
	parent: "والدین",
	parentCategory: "دسته اصلی",
	parentDepartment: "دپارتمان والد",
	parentTask: "مهمة والدی",
	parentType: "نوع والد",
	parentUser: "کاربر والد",
	participant: "شرکت کننده",
	passportEndDate: "تاریخ انقضای گذرنامه",
	passportImages: "تصاویر پاسپورت",
	passportNo: "شماره گذرنامه",
	passportStartDate: "تاریخ شروع گذرنامه",
	password: "رمز عبور",
	pause: "توقف",
	paused: "متوقف شده است",
	payDate: "تاریخ پرداخت",
	paymentMethod: "روش پرداخت",
	paymentMethods: "روش‌های پرداخت",
	paymentSystem: "سیستم پرداخت",
	payrollBreakdown: "جزئیات حقوق و دستمزد",
	payrollCalcError: "محاسبه حقوق و دستمزد ناموفق بود.",
	payrollCalcHint: "کارمند و بازه زمانی الزامی است. برای محاسبه و ذخیره مجموع حقوق کلیک کنید.",
	payrollCalcMissingFields: "لطفا کارمند، شروع دوره و پایان دوره را انتخاب کنید.",
	payrollCommentsForEmployee: "نظرات برای کارمند",
	payrollGeneratedFromAttendance: "حقوق تولیدشده از حضور",
	payrollHealthInsurancePremium: "بیمه درمانی (حق بیمه)",
	payrollIndexLabel: "شماره",
	payrollIndexPlaceholder: "شاخص",
	payrollInternalNotes: "یادداشت‌های داخلی",
	payrollNotesSection: "یادداشت‌ها",
	payrollType: "نوع فیش حقوقی",
	payrollUsesHrSettings:
		"اضافه‌کاری، نرخ‌های مالیات و مزایای پیش‌فرض (ناهار، حمل‌ونقل، بهداشت) از تنظیمات منابع انسانی پیروی می‌کنند (سیستم → تنظیمات منابع انسانی).",
	pc: "رایانه",
	pcHealth: "سلامت رایانه",
	pcs: "کامپیوترها",
	pdf: "PDF",
	penalties: "جریمه‌ها",
	pending: "معلق",
	pensionAmount: "مبلغ بازنشستگی",
	pensionRate: "نرخ بازنشستگی",
	periodEnd: "زمان پایان",
	periodStart: "زمان شروع",
	permInput_calendarEvent_overlayCustomCalendars: "تقویم‌های سفارشی (فیلتر)",
	permInput_calendarEvent_overlayIt: "تقویم‌های فناوری اطلاعات (گارانتی PC)",
	permInput_calendarEvent_overlayPeople: "تقویم‌های افراد (منابع انسانی)",
	permInput_calendarEvent_overlayReminders: "لایه یادآورها",
	permInput_calendarEvent_overlayTasks: "وظایف (لایه‌های اولویت)",
	permInput_calendarEvent_overlayTickets: "لایه تیکت‌ها (ددلاین بر اساس دامنه)",
	permInput_chat_attachFile: "پیوست فایل",
	permInput_chat_calling: "تماس صوتی",
	permInput_chat_pin: "سنجاق کردن پیام",
	permInput_chat_searchFiles: "جستجو در فایل ها",
	permInput_chat_searchMessages: "جستجو در پیام ها",
	permInput_chat_sendMessage: "ارسال پیام",
	permInput_chat_star: "ستاره دار کردن پیام",
	permInput_chat_videoCalling: "تماس تصویری",
	permModuleCrud_download: "دانلود تقویم (واردات .ics)",
	permModuleCrud_upload: "آپلود تقویم (صادرات .ics)",
	permanentDelete: "حذف دائمی؟",
	permission: "مجوز",
	permissions: "مجوزها",
	persons: "اشخاص",
	phone: "تلفن",
	photo: "عکس",
	photos: "عکسها",
	pickEmoji: "انتخاب اموجی",
	pinnedMessages: "پيام هاي سنجاق شده",
	placed: "قرار داده شده",
	placedState: "وضعیت قرار دادن",
	placeholder: "متن نمایشی",
	platformDashboard: "داشبورد پلتفرم",
	platformSpecificSettings: "تنظیمات خاص پلتفرم",
	platforms: "پلتفرم ها",
	audioPlaybackSpeed: "سرعت پخش: {rate}. برای تغییر ضربه بزنید.",
	playbackMute: "بی‌صدا",
	playbackUnmute: "باصدا",
	playbackVoiceMessage: "پیام صوتی",
	playbackVideoMessage: "پیام ویدیویی",
	previewVoiceMessage: "پیش‌نمایش پیام صوتی",
	play: "پخش",
	playStatus: "وضعیت پخش",
	playing: "در حال پخش",
	playingComposition: "ترکیب در حال پخش",
	playingHistory: "تاریخچه پخش",
	playlist: "لیست پخش",
	playlistStatistics: "آمار لیست‌های پخش",
	playlistsWithAds: "لیست‌های پخش با تبلیغات",
	playlistsWithoutAds: "لیست‌های پخش بدون تبلیغات",
	podcast: "پادکست",
	podcastStreams: "جریان‌های پادکست",
	podcasts: "پادکست‌ها",
	ports: "پورت‌ها",
	position: "موقعیت شغلی",
	positionReviewDate: "تاریخ بررسی سمت",
	preDefinedFilters: "فیلترهای پیش تعریف شده",
	preview: "پیش نمایش",
	previous: "قبلی",
	previousStep: "مرحله قبلی",
	price: "قیمت",
	priceB2b: "قیمت شرکتی",
	priceBasic: "قیمت پایه",
	priceGroup1: "گروه قیمت 1",
	priceGroup2: "گروه قیمت 2",
	priceGroup3: "گروه قیمت 3",
	priceLists: "فهرست قیمت‌ها",
	printedCount: "تعداد چاپ‌شده",
	printer: "چاپگر",
	printers: "پرینترها",
	priority: "اولویت",
	priorityDescription: "قوانین برنامه ریزی",
	private: "خصوصی",
	privateChat: "چت خصوصی",
	privateChatDescription: "فقط کاربران انتخاب‌شده می‌توانند این چت را ببینند و به آن بپیوندند",
	problem: "مشکل",
	problemDescription: "توضیحات مشکل",
	problemGroup: "گروه مشکل",
	problemGroupSupervisorsPlaceholder: "کاربران مسئول رسیدگی به تیکت‌های این گروه مشکل",
	problemGroupSupervisorsTab: "ناظران",
	processTime: "زمان پردازش",
	processing: "در حال پردازش",
	progress: "پیشرفت",
	product: "محصول",
	productCare: "مراقبت محصول",
	products: "محصولات",
	productsLinked: "محصولات مرتبط",
	project: "پروژه",
	projectChanges: "تغییرات پروژه",
	projectDeadline: "مهلت پروژه",
	projectDetails: "جزئیات پروژه",
	projectEndDate: "تاریخ پایان پروژه",
	projectID: "شناسه پروژه",
	projectPartition: "بخش پروژه",
	projectPrice: "قیمت پروژه",
	projectPrice2: "قیمت پروژه",
	projectStartDate: "تاریخ شروع پروژه",
	projectType: "نوع پروژه",
	projectTypes: "انواع پروژه‌ها",
	projects: "پروژه ها",
	promoCode: "کد تبلیغاتی",
	promoCodes: "کدهای تخفیف",
	promoCodesAndCertificates: "کدهای تخفیف و گواهینامه‌ها",
	promotions: "تبلیغات",
	propertyNumber: "شماره ملکیت",
	providing: "ارائه",
	punchActivity: "فعالیت ورود و خروج",
	pto: "مرخصی با حقوق",
	partial: "جزئی",
	quantity: "تعداد",
	radioDashboard: "پیشخوان رادیو",
	radioManagementOverview: "نمای کلی مدیریت پخش رادیو",
	radioStatistics: "آمار رادیو",
	raises: "افزایش‌ها",
	ram: "رم",
	rate: "نرخ",
	rating: "امتیاز",
	readOnly: "فقط خواندنی",
	readOnlyChatNotice: "این چت برای اعضا فقط خواندنی است. فقط مدیران می توانند پیام بنویسند.",
	readyToGetStarted: "آماده شروع",
	recalculatePayroll: "محاسبه مجدد حقوق و دستمزد",
	recentClients: "مشتریان اخیر",
	recentContent: "محتواهای اخیر",
	recentMessages: "پیام‌های اخیر",
	recentOrders: "سفارش‌های اخیر",
	recentTickets: "بلیط‌های اخیر",
	recentTracks: "قطعات اخیر",
	refresh: "بازیابی",
	registeredAddress: "آدرس ثبت‌شده",
	regularHours: "ساعات عادی",
	regularHoursHrScheduleHint:
		"از تنظیمات منابع انسانی: روزهای کاری در دوره × ساعات کاری روزانه. قابل ویرایش.",
	regularPlaylists: "لیست‌های پخش عادی",
	relatedList: "فهرست مرتبط",
	relatedObjects: "اشیاء مرتبط",
	relatedProducts: "محصولات مرتبط",
	relatedTasks: "مهام مرتبطه",
	relations: "ارتباطات",
	remainingVacation: "تعطیلات باقیمانده",
	remote: "دورکار",
	remoteWorkDays: "روزهای دورکاری",
	remove: "حذف",
	removeFromList: "حذف از لیست",
	removeItem: "حذف مورد",
	removed: "حذف شد",
	reopen: "باز کردن مجدد",
	replaceableProduct: "محصول مستبدل",
	replaceableProducts: "محصولات قابل تعویض",
	replied: "پاسخ داده شده",
	reply: "پاسخ",
	request: "درخواست",
	requestedForUser: "درخواست برای",
	reset: "بازنشانی",
	responseTimeDistribution: "توزیع زمان پاسخ",
	responsible: "مسئولیت",
	responsibleAndUsers: "مسئولین و کاربران",
	restoreSelected: "بازیابی فایل های انتخابی",
	restored: "بازیابی شد",
	returning: "بازگشتی",
	revenue: "درآمد",
	revenueOverview: "بررسی درآمد",
	review: "مراجعه",
	rightNow: "همین حالا",
	role: "نقش",
	rom: "حافظه فقط خواندنی",
	room: "اتاق",
	routers: "روترها",
	rpaPrice: "قیمت کار بخش RPA",
	ruleName: "نام قانون",
	salary: "حقوق",
	salaryReviewDate: "تاریخ بررسی حقوق",
	sale: "فروش",
	salePrice: "قیمت فروش",
	salesBreakdownByCategory: "تجزیه فروش بر اساس دسته‌بندی",
	salesPerformanceOverTime: "عملکرد فروش در طول زمان",
	sat: "شنبه",
	save: "ذخیره",
	saveChanges: "ذخیره تغییرات",
	saveComment: "ذخیره نظر",
	saved: "ذخیره شد",
	schedulingDisabled: "برنامه ریزی غیرفعال است",
	schedulingEnabled: "برنامه ریزی فعال است",
	schedulingRules: "قوانین برنامه ریزی",
	search: "جستجو",
	searchByNameOrId: "جستجو بر اساس نام یا شناسه…",
	searchChat: "جستجوی چت...",
	searchChatGroups: "جستجوی گروه‌های چت...",
	searchConversations: "جستجوی گفتگوها...",
	searchResults: "نتایج جستجو",
	searchUsers: "جستجوی کاربران...",
	secondary: "ثانویه",
	seconds: "ثانیه",
	securityAcknowledge: "تأیید",
	securityActions: "اقدامات",
	securityActiveBadge: "فعال",
	securityActiveSessions: "جلسات فعال",
	securityActivityStatClicks: "کلیک‌ها",
	securityActivityStatKeys: "کلیدها",
	securityActivityStatMoves: "حرکت‌ها",
	securityActivityTimeline: "خط زمانی فعالیت",
	securityAdminNotes: "یادداشت مدیر",
	securityAdminNotesDevice: "یادداشت داخلی درباره این دستگاه...",
	securityAgentHeartbeat: "ضربان عامل",
	securityAlertClipPlural: "کلیپ‌های این صفحه بر اساس هشدار",
	securityAlertClipSingular: "کلیپ روی این صفحه بر اساس هشدار",
	securityAlertCount: "هشدار",
	securityAlertCountPlural: "هشدارها",
	securityAlertDrawerNoMedia:
		"هنوز رسانه‌ای به این هشدار وصل نیست. عامل به FFmpeg نیاز دارد. در Windows مسیر PATH یا FFMPEG_PATH را تنظیم کنید.",
	securityAlertDrawerVideoFailed:
		"فرمان ضبط ویدیو ارسال شد اما فایلی آپلود نشد. خطای عامل محتمل است — لاگ را بررسی کنید.",
	securityAlertDrawerVideoPending:
		"ویدیو در حال ضبط است و به‌زودی اینجا نمایش داده می‌شود. عامل در حال ضبط و آپلود است.",
	securityAlertRecordings: "ضبط‌های هشدار",
	securityAlertRecordingsOnly: "فقط ضبط‌های هشدار",
	securityAlertSt_acknowledged: "تأیید شده",
	securityAlertSt_false_positive: "مثبت کاذب",
	securityAlertSt_open: "باز",
	securityAlertSt_resolved: "حل‌شده",
	securityAlertsTitle: "هشدارهای امنیتی",
	securityAllDevices: "همه دستگاه‌ها",
	securityAllEventTypes: "همه انواع",
	securityAllRules: "همه قوانین",
	securityAllSeverities: "همه شدت‌ها",
	securityAllStatuses: "همه وضعیت‌ها",
	securityAppProcessTracking: "ردیابی برنامه/فرآیند",
	securityAppTracking: "ردیابی برنامه",
	securityAppUsageToday: "استفاده از برنامه امروز (دقیقه)",
	securityAssignedUser: "کاربر اختصاص‌یافته",
	securityBadgeAlertText: "هشدار",
	securityBadgeApp: "برنامه",
	securityBadgeApps: "برنامه‌ها",
	securityBadgeCapture: "ضبط",
	securityBadgeFiles: "فایل‌ها",
	securityBadgeOff: "خاموش",
	securityBadgeScr: "اسکرین",
	securityBadgeScreenshot: "اسکرین",
	securityBadgeVideo: "ویدیو",
	securityBadgeWeb: "وب",
	securityCapture: "ضبط",
	securityCaptureEnabledMaster: "ضبط فعال (اصلی)",
	securityCaptureEverySeconds: "فاصله ضبط (ثانیه)",
	securityCaptureMasterSwitch: "ضبط فعال (کلید اصلی)",
	securityCaptureModes: "حالت‌های ضبط",
	securityCaptureOffAlertBody:
		"ضبط در سطح دستگاه صریحاً غیرفعال است و سیاست را لغو می‌کند. هشدارها ایجاد می‌شوند اما اسکرین یا ویدیو ضبط نمی‌شود.",
	securityCaptureOffAlertTitle: "لغو ضبط: خاموش",
	securityCaptureRecorded: "ضبط ثبت شد",
	securityCaptureWhenOnDesc: "با روشن بودن اسکرین و ویدیو ممکن است؛ خاموش هر دو را غیرفعال می‌کند",
	securityChartMinutes: "دقیقه",
	securityChartVisits: "بازدید",
	securityClearFilters: "پاک کردن فیلترها",
	securityClickLeft: "چپ",
	securityClickMiddle: "وسط",
	securityClickPlain: "کلیک",
	securityClickRight: "راست",
	securityClipWord: "کلیپ",
	securityConnectedDevices: "دستگاه‌های متصل",
	securityCreated: "ایجاد شده",
	securityDeleteDevice: "حذف دستگاه",
	securityDeleteDeviceConfirm: "آیا مطمئن هستید که می‌خواهید حذف کنید",
	securityDeleteDeviceNote:
		"این فقط رکورد دستگاه امنیتی را حذف می‌کند. پروفایل رایانه در IT تحت تأثیر قرار نمی‌گیرد.",
	securityDeleteDeviceTitle: "حذف دستگاه امنیتی",
	securityDeleteMedia: "حذف",
	securityDeletePolicyConfirm: "این سیاست حذف شود؟",
	securityDevice: "دستگاه",
	securityDeviceFallback: "دستگاه",
	securityDeviceIdLabel: "شناسه دستگاه",
	securityDeviceNotFound: "دستگاه یافت نشد",
	securityDeviceSettings: "تنظیمات دستگاه",
	securityDeviceSettingsHint:
		"سیاست فعال را برای این دستگاه لغو می‌کند؛ در غیر این صورت از سیاست ارث می‌برد.",
	securityDevicesBreadcrumb: "دستگاه‌ها",
	securityDevicesTitle: "دستگاه‌های امنیتی",
	securityDevicesWithAlerts: "دستگاه‌ها با هشدار",
	securityDividerCapture: "ضبط",
	securityDividerNotes: "یادداشت",
	securityDividerTracking: "ردیابی",
	securityDuration: "مدت",
	securityEg15: "مثلاً 15",
	securityEg30: "مثلاً 30",
	securityEg300: "مثلاً 300",
	securityEg5: "مثلاً 5",
	securityEg60: "مثلاً 60",
	securityEnabled: "فعال",
	securityEnd: "پایان",
	securityEventFlushSeconds: "خالی‌سازی رویداد (ثانیه)",
	securityEventsCount: "رویداد",
	securityEventsCountPlural: "رویدادها",
	securityEvtAppProcess: "برنامه / فرآیند",
	securityEvtAppUsage: "استفاده از برنامه",
	securityEvtFileEvent: "رویداد فایل",
	securityEvtHeartbeat: "ضربان",
	securityEvtInputActivity: "فعالیت ورودی",
	securityEvtKeystroke: "فشردن کلید",
	securityEvtMouseClick: "کلیک ماوس",
	securityEvtSessionEnd: "پایان جلسه",
	securityEvtSessionStart: "شروع جلسه",
	securityEvtSystemBoot: "راه‌اندازی سیستم",
	securityEvtSystemShutdown: "خاموش شدن سیستم",
	securityEvtUsb: "رویداد USB",
	securityEvtUserLogin: "ورود کاربر",
	securityEvtUserLogout: "خروج کاربر",
	securityEvtWebVisit: "بازدید وب",
	securityEvtWorkstationLock: "صفحه قفل شد",
	securityEvtWorkstationUnlock: "صفحه باز شد",
	securityFailedLoadOverview: "بارگذاری نمای کلی امنیت ناموفق بود",
	securityFailedSavePolicy: "ذخیره سیاست ناموفق بود",
	securityFalsePositiveBtn: "مثبت کاذب",
	securityFileEventTracking: "رویداد فایل",
	securityFilterByDate: "فیلتر بر اساس تاریخ",
	securityFilterDateRange: "فیلتر بازه تاریخ",
	securityFilteredSuffix: "(فیلتر شده)",
	securityFps: "FPS",
	securityHostname: "نام میزبان",
	securityInputActivityCounts: "فعالیت ورودی (شمارش)",
	securityInputKeystrokeClickTracking: "ردیابی کلید و کلیک",
	securityInputModeActivityCountsShort: "فقط فعالیت — شمارش کلید/کلیک",
	securityInputModeActivityOnly: "فقط فعالیت (شمارش)",
	securityInputModeDisabled: "غیرفعال",
	securityInputModeDisabledShort: "غیرفعال — بدون معیار ورودی",
	securityInputModeEventsOnly: "فقط رویدادها",
	securityInputModeEventsStream: "فقط رویدادها — جریان خام",
	securityInputModeFullDetail: "جزئیات کامل (کلیدها و کلیک)",
	securityInputModeFullKeystrokes: "جزئیات کامل — کلیدها و موقع کلیک",
	securityInputModeShort: "حالت ورودی",
	securityInputTrackingMode: "حالت ردیابی ورودی",
	securityInternalNotesPlaceholder: "یادداشت داخلی...",
	securityKeyCharPrefix: "کلید:",
	securityLastSeen: "آخرین مشاهده",
	securityLatestClip: "آخرین کلیپ",
	securityLinkedItPc: "رایانه IT مرتبط:",
	securityLiveLoadingSub: "در حال اتصال به عامل — پیش‌نمایش صفحه به‌زودی نمایش داده می‌شود.",
	securityLiveOfflineHint: "دستگاه آفلاین است — نمای زنده به عامل متصل نیاز دارد.",
	securityLivePressStart: "برای باز کردن استریم «شروع پخش زنده» را بزنید.",
	securityLiveScreenAlt: "صفحه زنده",
	securityLiveStatusLive: "زنده",
	securityLiveStatusStandby: "آماده‌به‌کار",
	securityLiveStreamHint: "استریم نیم‌رزولوشن، تا ۱۰ فریم بر ثانیه. عامل v1.4.0+ با jimp.",
	securityLiveWaitingFrames: "در حال بارگذاری پخش زنده…",
	securityLoggedInSince: "ورود از",
	securityLoggedOutSince: "آخرین خروج",
	securityMediaPrefix: "رسانه",
	securityMediaTitle: "رسانه امنیتی",
	securityMiddleClick: "کلیک وسط",
	securityModuleErrorTitle: "خطای ماژول امنیت",
	securityName: "نام",
	securityNearbyScreenshots: "اسکرین‌شات‌های نزدیک",
	securityNever: "هرگز",
	securityNewMediaBadge: "جدید",
	securityNewPolicy: "سیاست جدید",
	securityNoActivityEvents: "رویداد فعالیتی نیست",
	securityNoAlertRecordingsPage: "ضبط هشدار در این صفحه نیست",
	securityNoAlertsForDevice: "هشداری برای این دستگاه نیست",
	securityNoAlertsFound: "هشداری یافت نشد",
	securityNoDevicesFound: "دستگاهی یافت نشد",
	securityNoEventsMatchFilter: "رویدادی با این فیلتر مطابقت ندارد",
	securityNoOpenAlerts: "هشدار بازی وجود ندارد",
	securityNoPoliciesConfigured: "سیاستی پیکربندی نشده. برای نظارت یکی بسازید.",
	securityNoPreview: "پیش‌نمایش ندارد",
	securityNoRiskyDevices: "دستگاه پرریسک وجود ندارد",
	securityNoScreenshotsFound: "اسکرین‌شاتی نیست",
	securityNoScreenshotsYet: "هنوز اسکرین‌شاتی نیست",
	securityNoSessionsFound: "جلسه‌ای یافت نشد",
	securityNoSessionsRecorded: "جلسه‌ای ثبت نشده",
	securityNoUserSession: "بدون نشست کاربری",
	securityNoUserSessionLiveHint:
		"رایانه روشن است اما کاربری وارد نشده؛ نمای زنده و اسکرین‌شات در دسترس نیست.",
	securityNoUserSessionTitle: "هیچ کاربری وارد نشده",
	securityNoVideoSegmentsFound: "بخش ویدیویی نیست",
	securityNoVideosYet: "هنوز بخش ویدیویی نیست",
	securityOS: "سیستم‌عامل",
	securityOnlineDevices: "دستگاه‌های آنلاین",
	securityOpenAlerts: "هشدارهای باز",
	securityOpenPcRecord: "باز کردن رکورد PC",
	securityOverrideOff: "خاموش",
	securityOverrideOn: "روشن",
	securityOverridePrefix: "لغو:",
	securityOverviewTitle: "نمای کلی امنیت",
	securityPageOf: "صفحه",
	securityPolActivityTrackingDivider: "ردیابی فعالیت",
	securityPolAfterHoursStart: "شروع خارج از ساعت کاری",
	securityPolAlertClipLength: "طول کلیپ ویدیوی هشدار (ثانیه)",
	securityPolAlertScore: "امتیاز هشدار (۰–۱۰۰)",
	securityPolAlertSeverity: "شدت هشدار",
	securityPolAlertVideoDivider: "ضبط ویدیو هنگام هشدار",
	securityPolAlertVideoInfo:
		"با فعال شدن قانون، عامل یک کلیپ دسکتاپ با تنظیمات زیر ضبط می‌کند. طول و کیفیت برای همه قوانین یکسان است.",
	securityPolAllowedHoursDivider: "ساعات مجاز ضبط",
	securityPolBadgeAlert: "هشدار",
	securityPolBlockedApps: "برنامه‌های مسدود",
	securityPolBlockedAppsPh: "مثلاً telegram، discord، torrent",
	securityPolBlockedDomains: "دامنه‌های مسدود",
	securityPolBlockedDomainsPh: "مثلاً torrent-site.com، telegram.org",
	securityPolBreadcrumbPolicies: "سیاست‌ها",
	securityPolBulkThreshold: "آستانه رویداد انبوه فایل (رویداد/دسته)",
	securityPolBulkThresholdDesc: "تعداد رویدادهای مخرب فایل در یک دسته آپلود برای فعال شدن",
	securityPolCollectInputMetrics: "جمع معیارهای فعالیت ورودی",
	securityPolCollectInputMetricsDesc: "فقط شمارش رویداد ماوس/صفحه‌کلید (بدون محتوای کلید)",
	securityPolCreateAlert: "ایجاد هشدار",
	securityPolCreateAlertDesc: "با تطابق قانون، هشدار امنیتی باز می‌شود (ویدیو از تب ضبط)",
	securityPolDescription: "توضیحات",
	securityPolEditPolicy: "ویرایش سیاست",
	securityPolEnableRule: "فعال‌سازی قانون",
	securityPolEventsRetention: "نگهداری رویدادها (روز)",
	securityPolEventsRetentionDesc: "رکوردهای فعالیت قدیمی‌تر پاک می‌شوند",
	securityPolExcludedDomains: "دامنه‌های مستثنی",
	securityPolExcludedDomainsPh: "مثلاً online-banking.com",
	securityPolExcludedProcesses: "نام فرآیندهای مستثنی",
	securityPolExcludedProcessesPh: "مثلاً 1Password، Bitwarden",
	securityPolInputActivityCounts: "فقط فعالیت — شمارش رویداد ماوس/کلید",
	securityPolInputDisabledNoTrack: "غیرفعال — ورودی ردیابی نشود",
	securityPolInputEventsCount: "فقط رویدادها — فقط شمارش کلید",
	securityPolInputFullDetail: "جزئیات کامل — کلیدها و موقع کلیک",
	securityPolInputModeLabel: "حالت ردیابی ورودی",
	securityPolInputTrackingDivider: "ردیابی ورودی",
	securityPolMaskSensitive: "پوشاندن پنجره‌های حساس (مدیر رمز، بانک)",
	securityPolMaskSensitiveDesc: "اسکرین برای برنامه/پنجره‌های مستثنی گرفته نشود",
	securityPolMaxFps: "حداکثر FPS",
	securityPolMediaRetention: "نگهداری رسانه (روز)",
	securityPolMediaRetentionDesc: "اسکرین‌شات و ویدیوهای قدیمی‌تر حذف می‌شوند",
	securityPolNewSecurityPolicy: "سیاست امنیتی جدید",
	securityPolNotifyUsersDesc:
		"کاربران انتخاب‌شده هنگام فعال شدن هر قانون در این سیاست اطلاع‌رسانی درون‌برنامه‌ای دریافت می‌کنند.",
	securityPolNotifyUsersLabel: "هنگام فعال شدن سیاست به مدیران اطلاع بده",
	securityPolNotifyUsersPh: "کاربران برای اطلاع‌رسانی را جستجو کنید…",
	securityPolPolicyName: "نام سیاست",
	securityPolPolicyNamePh: "مثلاً سیاست تیم توسعه",
	securityPolPriority: "اولویت",
	securityPolPriorityDesc: "عدد بیشتر = اول ارزیابی می‌شود",
	securityPolRecordVideoOnAlert: "ضبط ویدیو هنگام هشدار امنیتی",
	securityPolRecordVideoOnAlertDesc: "خاموش: هشدار ایجاد می‌شود اما ویدیو ضبط نمی‌شود",
	securityPolRuleAfterHoursDesc: "وقتی فعالیت خارج از ساعات کاری تعریف‌شده تشخیص داده شود.",
	securityPolRuleAfterHoursLabel: "فعالیت خارج از ساعت کاری",
	securityPolRuleBlockedAppDesc: "وقتی کاربر نظارت‌شده برنامه‌ای از لیست مسدود باز می‌کند.",
	securityPolRuleBlockedAppLabel: "برنامه مسدود",
	securityPolRuleBlockedDomainDesc: "وقتی کاربر نظارت‌شده دامنه‌ای از لیست مسدود را بازدید می‌کند.",
	securityPolRuleBlockedDomainLabel: "دامنه مسدود",
	securityPolRuleBulkFileDesc: "وقتی حذف/تغییر نام/جابجایی زیاد فایل در یک دسته رخ دهد.",
	securityPolRuleBulkFileLabel: "عملیات انبوه فایل",
	securityPolRuleUsbDesc: "وقتی ذخیره USB به دستگاه نظارت‌شده وصل می‌شود.",
	securityPolRuleUsbLabel: "ذخیره USB شناسایی شد",
	securityPolRulesIntro:
		"قوانین تخلف و امتیاز هشدار را تعریف می‌کنند. با «ایجاد هشدار»، هشدار امنیتی ایجاد می‌شود؛ ویدیو طبق تب ضبط (یکسان برای همه).",
	securityPolSavePolicy: "ذخیره سیاست",
	securityPolScope: "محدوده",
	securityPolScopeDepartment: "بخش",
	securityPolScopeDevice: "دستگاه‌های مشخص",
	securityPolScopeGlobal: "سراسری — برای همه دستگاه‌ها",
	securityPolScopeUser: "کاربران مشخص",
	securityPolTabCapture: "ضبط",
	securityPolTabPrivacy: "حریم خصوصی و استثناها",
	securityPolTabRetention: "نگهداری",
	securityPolTabRules: "قوانین",
	securityPolTrackApps: "ردیابی برنامه‌های فعال",
	securityPolTrackFiles: "ردیابی فعالیت فایل",
	securityPolTrackWebsites: "ردیابی بازدید وب‌سایت",
	securityPolTrackingMaster: "ردیابی فعال (کلید اصلی)",
	securityPolTrackingMasterDesc: "خاموش: ردیابی برنامه، وب، فایل و ورودی غیرفعال است",
	securityPolVisibleNotice: "نمایش اعلان قابل‌مشاهده نظارت به کارکنان",
	securityPolVisibleNoticeDesc: "نوار اطلاع‌رسانی فعال بودن نظارت را نشان می‌دهد",
	securityPolWorkDayStart: "شروع روز کاری (پایان خارج از ساعت)",
	securityPolWorkingHours: "ساعات کاری (اختیاری)",
	securityPolWorkingHoursDesc:
		"فقط در این بازه ضبط شود. قالب: ساعت:دقیقه-ساعت:دقیقه. خالی = همیشه.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"نشان‌ها نشان می‌دهند چه چیزی فعال است. برای روشن یا خاموش کردن اسکرین‌شات، ویدیو، برنامه‌ها، وب یا فایل‌ها، خط‌مشی را باز کنید (مداد) → تب «ضبط».",
	securityPoliciesTitle: "سیاست‌های امنیتی",
	securityPolicyDefaultBadge: "پیش‌فرض سیاست",
	securityPriority: "اولویت",
	securityQueued: "در صف!",
	securityRecentOpenAlerts: "هشدارهای باز اخیر",
	securityRecentScreenshots: "اسکرین‌شات‌های اخیر",
	securityRecordEverySeconds: "ضبط هر (ثانیه)",
	securityRecordVideo30s: "ضبط ویدیو (۳۰ ثانیه)",
	securityRefresh: "بازخوانی",
	securityResolution: "وضوح",
	securityResolutionNotePlaceholder: "یادداشت حل (اختیاری)",
	securityResolve: "حل کردن",
	securityRightClick: "کلیک راست",
	securityRule: "قانون",
	securityRuleCode_AFTER_HOURS: "خارج از ساعت کاری",
	securityRuleCode_BLOCKED_APP: "برنامه مسدود",
	securityRuleCode_BLOCKED_DOMAIN: "دامنه مسدود",
	securityRuleCode_BULK_FILE_EVENTS: "رویدادهای انبوه فایل",
	securityRuleCode_USB_DETECTED: "USB شناسایی شد",
	securitySaveSettings: "ذخیره تنظیمات",
	securitySaved: "ذخیره شد",
	securityScope: "محدوده",
	securityScopeType_department: "بخش",
	securityScopeType_device: "دستگاه",
	securityScopeType_global: "سراسری",
	securityScopeType_user: "کاربر",
	securityScreenshotAlt: "اسکرین‌شات",
	securityScreenshotOptionsBlank: "گزینه اسکرین (خالی = پیش‌فرض سیاست)",
	securityScreenshots: "اسکرین‌شات",
	securityScreenshotsCount: "اسکرین‌شات",
	securityScreenshotsLabel: "اسکرین‌شات",
	securityScreenshotsToday: "اسکرین‌شات‌های امروز",
	securitySearch: "جستجو",
	securitySearchDevicesPlaceholder: "جستجوی نام میزبان، شناسه دستگاه، کاربر...",
	securitySegmentLengthSeconds: "طول بخش (ثانیه)",
	securitySelectedCount: "انتخاب‌شده",
	securitySessionActive: "فعال",
	securitySessionIdle: "بیکار",
	securitySessionLocked: "صفحه قفل است",
	securitySessionLockedCaptureHint: "صفحه قفل است — اسکرین‌شات و نمای زنده در دسترس نیست.",
	securitySessionLockedLiveHint:
		"کاربر صفحه را قفل کرده است. در حین قفل بودن صفحه، نمای زنده، اسکرین‌شات و ضبط غیرفعال است.",
	securitySessionLockedSince: "قفل از",
	securitySessionLockedTitle: "صفحه قفل شده",
	securitySessionNotFound: "جلسه یافت نشد",
	securitySessionTimeline: "خط زمانی جلسه",
	securitySessionWord: "جلسه",
	securitySessionsTitle: "جلسات",
	securitySettingsDrawerTitle: "تنظیمات",
	securitySettingsOverrideHint:
		"فقط برای این دستگاه سیاست را لغو می‌کند؛ بدون تغییر از سیاست ارث می‌برد.",
	securitySev_critical: "بحرانی",
	securitySev_high: "بالا",
	securitySev_low: "پایین",
	securitySev_medium: "متوسط",
	securitySeverity: "شدت",
	securityShowAllVideos: "نمایش همه ویدیوها",
	securitySourceEvents: "رویدادهای منبع",
	securitySpeedSec: "سرعت (ثانیه):",
	securityStart: "شروع",
	securityStartLive: "شروع پخش زنده",
	securityStatOf: "از",
	securityStatus: "وضعیت",
	securityStatus_error: "خطا",
	securityStatus_offline: "آفلاین",
	securityStatus_online: "آنلاین",
	securityStatus_pending: "در انتظار",
	securityStatus_unknown: "نامشخص",
	securityStopLive: "توقف پخش زنده",
	securityTabActivity: "فعالیت",
	securityTabAlerts: "هشدارها",
	securityTabLive: "زنده",
	securityTabScreenshots: "اسکرین‌شات",
	securityTabSessions: "جلسات",
	securityTabSettings: "تنظیمات",
	securityTabVideos: "ویدیوها",
	securityTakeScreenshot: "گرفتن اسکرین‌شات",
	securityTitle: "عنوان",
	securityTooltipAppTrack: "ردیابی برنامه",
	securityTooltipCaptureMaster: "ضبط اسکرین و رسانه (اصلی)",
	securityTooltipScreenshot: "ضبط اسکرین‌شات",
	securityTooltipTrackingMaster: "کلید اصلی ردیابی برنامه، وب، فایل و ورودی",
	securityTooltipWebTrack: "ردیابی دامنه",
	securityTopRiskyDevices: "پرریسک‌ترین دستگاه‌ها",
	securityTracking: "ردیابی",
	securityTrackingEnabledMaster: "ردیابی فعال (اصلی)",
	securityTrackingMasterSwitch: "ردیابی فعال (اصلی)",
	securityTrackingOffAlertBody:
		"ردیابی فعالیت در سطح دستگاه صریحاً غیرفعال است و سیاست را لغو می‌کند.",
	securityTrackingOffAlertTitle: "لغو ردیابی: خاموش",
	securityTrackingWhenOffDesc: "خاموش بودن ردیابی برنامه، وب، فایل و ورودی را غیرفعال می‌کند",
	securityUnassigned: "اختصاص نیافته",
	securityUnknown: "نامشخص",
	securityUnknownDevice: "دستگاه ناشناخته",
	securityUsePolicyDefault: "پیش‌فرض سیاست",
	securityUser: "کاربر",
	securityUserLoggedIn: "وارد شده",
	securityVideoOffAlertBody:
		"ضبط ویدیو در سطح دستگاه غیرفعال است؛ حتی اگر سیاست اجازه دهد ضبط هشدار انجام نمی‌شود.",
	securityVideoOffAlertTitle: "لغو ویدیو: خاموش",
	securityVideoOptionsBlank: "گزینه ویدیو (خالی = سیاست)",
	securityVideoPlayAllHint:
		"پخش همه از کلیپ انتخاب‌شده به قدیمی‌ترها؛ با پایان صفحه، صفحه بعد بارگذاری می‌شود.",
	securityVideoRecording: "ضبط ویدیو",
	securityVideoSegments: "بخش‌های ویدیو",
	securityVideoSegmentsCount: "بخش‌های ویدیو",
	securityViewDetail: "جزئیات",
	securityWebDomainTracking: "ردیابی دامنه",
	securityWebPollSeconds: "نظرسنجی تاریخچه وب (ثانیه)",
	securityWebTracking: "وب",
	securityWebsiteVisitsToday: "بازدید سایت امروز",
	securityWhen: "زمان",
	selectAlbum: "آلبوم را انتخاب کنید",
	selectAll: "همه را انتخاب کنید",
	selectArtist: "فنی را انتخاب کنید",
	selectBoard: "لوحة را انتخاب کنید",
	selectCategory: "فئه را انتخاب کنید",
	selectChatPartner: "انتخاب شریک چت",
	selectClosedDate: "تاریخ بسته‌شدن را انتخاب کنید",
	selectDate: "تاریخ را انتخاب کنید",
	selectDays: "روزها را انتخاب کنید",
	selectDomain: "انتخاب حوزه",
	selectEmployee: "کارمند را انتخاب کنید",
	selectFiles: "انتخاب فایل‌ها",
	selectGroup: "انتخاب گروه",
	selectOpenedDate: "تاریخ باز شدن را انتخاب کنید",
	selectParentDepartment: "دپارتمان والد را انتخاب کنید",
	selectParentUser: "کاربر والد را انتخاب کنید",
	selectPeriod: "دوره را انتخاب کنید",
	selectPlatformToManageAndNavigate: "داشبورد پلتفرم را انتخاب کنید",
	selectPlaylist: "فهرست پخش را انتخاب کنید",
	selectProduct: "انتخاب محصول",
	selectSomething: "چیزی انتخاب کنید",
	selectUsers: "انتخاب کاربران",
	selectedSteps: "مراحل انتخاب شده",
	selectedUsers: "کاربران انتخاب‌شده",
	seleteSelected: "فایل های انتخابی را انتخاب کنید",
	send: "ارسال",
	sent: "ارسال شده",
	seoDesc: "توضیحات SEO",
	servicesAndPrices: "خدمات و قیمت‌ها",
	setCostOfBuildingPermit: "هزینه مجوز ساخت را تنظیم کنید",
	setDayOff: "تنظیم روز تعطیل",
	settings: "تنظیمات",
	shiftSchedule: "برنامه شیفت",
	showAllSteps: "نمایش همه مراحل",
	showHistory: "نمایش تاریخ",
	showProjectDetails: "نمایش جزئیات پروژه",
	showTableColumnFilters: "نمایش فیلترهای ستون",
	showTimeline: "نمایش خط زمانی",
	showing: "نمایش داده شده",
	shuffle: "درهم",
	shuffleEnabled: "ترتیب تصادفی فعال",
	shuffleOverride: "قوانین برنامه ریزی",
	shuffleOverrideDesc: "قوانین برنامه ریزی",
	shuffleOverrideValue: "قوانین برنامه ریزی",
	sickLeave: "مرخصی استعلاجی",
	sickLeaveDays: "روزهای مرخصی استعلاجی",
	signIn: "ورود",
	signUp: "ثبت نام",
	size: "اندازه",
	slider: "اسلایدر",
	small: "کوچک",
	smb: "پوشه سرور",
	socialAmount: "مبلغ پرداخت اجتماعی",
	socialCardImages: "تصاویر کارت اجتماعی",
	socialCart: "کارت اجتماعی",
	socialNetworkLink: "لینک شبکه اجتماعی",
	socialRate: "نرخ پرداخت اجتماعی",
	software: "نرم‌افزار",
	softwareSkills: "مهارت‌های نرم‌افزاری",
	somethingWentWrong: "چیزی اشتباه پیش رفت",
	somethingWentWrongInCreatingSteps: "در ایجاد مراحل مشکلی پیش آمد! لطفاً دوباره تلاش کنید",
	sortBy: "مرتب سازی",
	source: "منبع",
	special: "ویژه",
	specialItems: "آیتم‌های ویژه",
	speed: "سرعت",
	starred: "مرصوف",
	starredMessages: "پيام هاي ستاره دار",
	start: "شروع",
	startCall: "شروع تماس",
	startDate: "تاریخ شروع",
	startDateShort: "تاریخ شروع",
	startRecording: "شروع ضبط",
	startTime: "زمان شروع",
	startVideoCall: "شروع تماس تصویری",
	starts: "شروع می‌شود",
	state: "استان",
	states: "ایالت‌ها",
	status: "وضعیت",
	visibility: "قابلیت مشاهده",
	statusUpdate: "بروزرسانی وضعیت",
	stayAnonymous: "ناشناس بمانید",
	step: "گام",
	stepIsNotStartedYet: "مرحله هنوز شروع نشده است",
	stepStatus: "وضعیت مرحله",
	stepStatusChangedByUser: "وضعیت مرحله توسط کاربر تغییر یافت",
	steps: "مراحل",
	stepsLeft: "مراحل باقی‌مانده",
	stillInOffice: "هنوز در دفتر",
	stockAndProductOverview: "بررسی موجودی و محصولات",
	stop: "توقف",
	stopRecording: "توقف از ضبط",
	stopped: "متوقف شده است",
	streamDJ: "DJ رادیویی",
	streamStatistics: "آمار جریان‌ها",
	streaming: "استریمینگ",
	streamsWithShuffle: "جریان‌های با ترتیب تصادفی",
	street: "خیابان",
	subDesc: "توضیحات فرعی",
	submit: "ارسال",
	submittedProjects: "پروژه‌های ارسال شده",
	subscription: "اشتراک",
	subscriptions: "اشتراک‌ها",
	substation: "ایستگاه فرعی",
	substationNumber: "شماره ایستگاه فرعی",
	subtasks: "مهام فرعی",
	subtasksPlaceholder: "هر زیر مهمت را در یک خط جدید وارد کنید",
	subtitle: "زیرعنوان",
	success: "موفقیت",
	suffix: "سونیک",
	sun: "یکشنبه",
	support: "پشتیبانی",
	supportText: "برای تمام سوالات بنویسید",
	switch: "سوئیچ",
	switchers: "سوئیچ‌ها",
	switches: "پرینترها",
	syncedFromGoogleContacts: "همگام‌سازی‌شده از Google Contacts",
	systemSettings: "تنظیمات سیستم",
	table: "جدول",
	tag: "برچسب",
	tags: "برچسب",
	takeMeHome: "برگرد به خانه",
	taskCreatedSuccessfully: "کار با موفقیت ایجاد شد",
	taskCreatedSuccessfullyDescription: "کار با موفقیت ایجاد شد",
	taskDescription: "وصف کار",
	taskMoved: "کار تغییر مکان یافت",
	taskMovedDescription: "کار به یک دسته جدید حرکت کرد",
	taskStatusDistribution: "توزیع وضعیت کار",
	taskTitle: "عنوان کار",
	tasksAssigned: "وظایف محول شده",
	taxCode: "کد مالیاتی",
	taxNote: "برچسب",
	taxes: "مالیات‌ها",
	technicalFilesUrl: "آدرس فایل‌های فنی",
	telegram: "تلگرام",
	text: "متن",
	theConstructionDepPrice: "قیمت بخش ساخت و ساز",
	theNumberOfAct: "تعداد عمل",
	thePriceOfProject: "قیمت پروژه",
	themePickerLabel: "تم",
	thereIsNoResponsible: "هیچ مسئولی وجود ندارد",
	thisMonth: "این ماه",
	thu: "پنج‌شنبه",
	ticket: "بلیت",
	ticketClosed: "بلیت بسته شد",
	ticketCreateSaveDisabledHint:
		"دامنه، گروه مشکل (در صورت وجود)، مشکل را انتخاب کنید و فیلدهای مرتبط الزامی را قبل از ذخیره پر کنید.",
	ticketDashboard: "پیشخوان بلیط",
	ticketDomain: "حوزه",
	ticketHierarchyAddProblem: "افزودن مسئله",
	ticketHierarchyAddProblemGroup: "افزودن گروه مشکل",
	ticketHierarchyAddRelatedList: "افزودن فهرست مرتبط",
	ticketHierarchyAddTicket: "افزودن تیکت",
	ticketHierarchyAddTicketDomain: "افزودن حوزه",
	ticketHierarchyAddTicketHint: "ایجاد تیکت جدید با این دامنه از پیش انتخاب‌شده باز می‌شود.",
	ticketHierarchyGroupsInDomain: "گروه‌های مشکل در این حوزه",
	ticketHierarchyNoneYet: "هنوز نیست — از دکمه بالا استفاده کنید.",
	ticketHierarchyProblemsInGroup: "مسائل در این گروه",
	ticketHierarchyProblemsLinkedToList: "مسائلی که از این فهرست استفاده می‌کنند",
	ticketSystemOverview: "نمای کلی عملکرد و معیارهای سیستم بلیط",
	ticketTitle: "عنوان",
	ticketType: "نوع",
	ticketTypeDomainsHint:
		"خالی بگذارید تا در همه دامنه‌ها در دسترس باشد؛ یک یا چند دامنه انتخاب کنید تا فقط آنجا نمایش داده شود.",
	ticketTypeDomainsListAll: "همه دامنه‌ها",
	ticketStatus_sent: "ارسال شده",
	ticketStatus_in_process: "در حال پردازش",
	ticketStatus_resolved_rejected: "رد شده",
	ticketStatus_resolved_approved: "تأیید شده",
	ticketStatus_moved_next: "به مرحله بعد منتقل شد",
	ticketStatus_moved_prev: "به مرحله قبل برگشت",
	ticketStatus_closed: "بسته شده",
	ticketStatus_not_accepted: "پذیرفته نشد",
	ticketAction_start: "شروع پردازش",
	ticketAction_next: "مرحله بعد",
	ticketAction_prev: "مرحله قبل",
	ticketAction_approve: "تأیید",
	ticketAction_reject: "رد",
	ticketAction_close: "بستن تیکت",
	ticketAction_cancel: "لغو تیکت",
	ticketAction_comment: "نظر",
	cancelTicket: "لغو تیکت",
	ticketCancelReason: "دلیل لغو",
	ticketCancelComment: "توضیح تکمیلی",
	ticketCancelCommentPlaceholder: "در صورت نیاز جزئیاتی برای ثبت‌کننده اضافه کنید",
	ticketCancelWarning:
		"این تیکت به عنوان پذیرفته‌نشده علامت‌گذاری و بسته می‌شود. اگر کاربر هنوز به کمک نیاز دارد، باید تیکت جدیدی ایجاد کند.",
	ticketNotAccepted: "تیکت پذیرفته نشد",
	ticketStepStatus_pending: "در انتظار",
	ticketStepStatus_active: "فعال",
	ticketStepStatus_completed: "تکمیل شده",
	ticketStepStatus_approved: "تأیید شده",
	ticketStepStatus_rejected: "رد شده",
	ticketStepStatus_closed: "بسته شده",
	ticketStepStatus_cancelled: "لغو شده",
	tickets: "بلیط‌ها",
	ticketsByDepartment: "بلیط‌ها بر اساس بخش",
	ticketsByImportance: "بلیط‌ها بر اساس اولویت",
	ticketsByProblem: "بلیط‌ها بر اساس نوع مشکل",
	ticketsByStatus: "بلیط‌ها بر اساس وضعیت",
	ticketsOverTime: "بلیط‌ها در طول زمان",
	timAgreement: "توافق TIM",
	timDelays: "تاخیرات TIM",
	timSentProjects: "پروژه‌های ارسال شده به TIM",
	time: "زمان",
	timeBasedScheduling: "برنامه ریزی بر اساس زمان",
	timeOff: "مرخصی",
	timeRange: "بازه زمانی",
	timeToClose: "زمان بستن بلیط",
	timeToFirstResponse: "زمان اولین پاسخ",
	timeline: "خط زمانی",
	timestamp: "برچسب زمانی",
	timezone: "منطقه زمانی",
	title: "عنوان",
	to: "تا",
	toChat: "به چت",
	toDo: "برای انجام دادن",
	today: "امروز",
	todaysSales: "فروش امروز",
	todo: "کارها",
	todoBoard: "بورد",
	todoBoards: "بوردها",
	todoCategories: "دسته‌ها",
	todoCategory: "دسته",
	todoLabel: "برچسب",
	todoLabels: "برچسب‌ها",
	todoTag: "برچسب",
	todoTags: "برچسب‌ها",
	todoTask: "کار",
	todoTasks: "کارها",
	toggles: "تغییرات",
	top: "برتر",
	topCustomers: "مشتریان برتر",
	topProducts: "محصولات برتر",
	total: "جمع",
	totalActiveTasks: "کل وظایف فعال",
	totalArtists: "کل هنرمندان",
	totalChats: "کل چت‌ها",
	totalClients: "کل مشتریان",
	totalCoins: "کل سکه‌ها",
	totalContent: "کل محتوا",
	totalCustomers: "کل مشتریان",
	totalDeductions: "جمع کسور",
	totalDuration: "مدت زمان کل",
	totalGroups: "کل گروه‌ها",
	totalHours: "کل ساعات",
	missingDays: "روزهای غایب",
	missingHours: "ساعات غایب",
	scheduled: "برنامه‌ریزی‌شده",
	totalHoursWorked: "کل ساعات کار",
	totalInTrash: "سل قرار خواهد گرفت",
	totalMessages: "کل پیام‌ها",
	totalOrders: "کل سفارش‌ها",
	totalOvertime: "جمع کل اضافه کاری",
	totalPlaylists: "کل لیست‌های پخش",
	totalPrice: "قیمت کل",
	totalProducts: "کل محصولات",
	totalRevenue: "کل درآمد",
	totalTickets: "کل بلیط‌ها",
	totalTracks: "کل قطعات",
	totalUses: "کل استفاده‌ها",
	totalValue: "کل ارزش",
	track: "ترک",
	trackPlaylist: "لیست پخش آهنگ",
	tracks: "ترک‌ها",
	tracksByArtist: "قطعات بر اساس هنرمند",
	transportAllowance: "کمک هزینه حمل‌ونقل",
	trash: "سل قرار خواهد گرفت",
	trashAutoDeleteWarning: "هشدار حذف سل قرار خواهد گرفت",
	trashEmptied: "سل قرار خواهد گرفت",
	trashedOn: "حذف شده در",
	tryAgain: "دوباره تلاش کنید",
	tue: "سه‌شنبه",
	type: "نوع",
	uncoveredInterval: "بازه پوشش‌نیافته",
	undefined: "تعریف نشده",
	undo: "واگرد",
	university: "دانشگاه",
	universityDegree: "مدرک دانشگاهی",
	universityDepartment: "دانشکده دانشگاه",
	unjustifiedAbsence: "غیبت غیرموجه",
	unknown: "ناشناخته",
	unknownArtist: "هنرمند نامشخص",
	unnamed: "بدون نام",
	unnamedClient: "مشتری بدون نام",
	unnamedTrack: "قطعه بدون نام",
	unpaid: "بدون حقوق",
	unreadMessages: "پیام‌های خوانده نشده",
	unresolvedMissingIntervals: "بازه‌های ناقص حل‌نشده — حقوق ممکن است دقیق نباشد",
	upcomingBirthdays: "تولدهای آینده",
	update: "به‌روزرسانی",
	updatedAt: "تاریخ بروزرسانی",
	updates: "به روز رسانی ها",
	upload: "آپلود",
	uploadDate: "تاریخ بارگذاری",
	uploading: "در حال بارگذاری",
	uploads: "آپلودها",
	uptime: "مدت زمان روشن بودن",
	urgent: "مهم",
	used: "استخدام شده",
	usedCount: "تعداد استفاده شده",
	usedVacation: "تعطیلات استفاده شده",
	user: "کاربر",
	userArchive: "آرشیو کاربر",
	userDashboard: "پیشخوان کاربر",
	userDeleted: "حذف شد",
	userEntered: "کاربر وارد شد",
	userProfile: "پروفایل کاربر",
	userPayrollCalcUsesAttendance:
		"این محاسبه از خلاصه رسمی حضور و مرخصی برای {monthKey} استفاده می‌کند و سپس قوانین مالیاتی فعال را از تنظیمات منابع انسانی اعمال می‌کند.",
	userUpdated: "به‌روزرسانی شد",
	userVisited: "کاربر بازدید کرد",
	username: "نام کاربری",
	users: "منابع انسانی",
	vacationBalance: "موجودی تعطیلات",
	vacationDaysForPeriod: "روزهای تعطیلات برای دوره انتخابی",
	vacationInterval: "بازه تعطیلات",
	vacationPay: "حقوق مرخصی",
	value: "ارزش",
	version: "نسخه",
	viber: "Viber",
	video: "ویدیو",
	view: "مشاهده",
	viewAll: "نمایش همه",
	viewDetails: "مشاهده جزئیات",
	viewMore: "مشاهده بیشتر",
	viewProject: "مشاهده پروژه",
	viewSteps: "مشاهده مراحل",
	viewTrash: "نمایش سل قرار خواهد گرفت",
	village: "روستا",
	villages: "لیست مناطق",
	visitation: "بازدید",
	visitationDeadline: "مهلت بازدید",
	visitationDelays: "تاخیرات بازدید",
	voltage: "ولتاژ",
	voltageLevel: "سطح ولتاژ",
	volumes: "حجم‌ها",
	voluntaryPensionAmount: "مبلغ بازنشستگی داوطلبانه",
	voluntaryPensionRate: "نرخ بازنشستگی داوطلبانه (٪)",
	vsPreviousPeriod: "در مقایسه با دوره قبلی",
	warning: "هشدار",
	warrantyDesc: "توضیحات گارانتی",
	warrantyEnd: "گارانتی پایان",
	warrantyProvider: "تامین کننده گارانتی",
	warrantyStart: "گارانتی شروع",
	watchers: "مشاهده کننده",
	weatherAriaYerevanForecast: "پیش‌بینی آب‌وهوای ایروان",
	weatherCityYerevan: "ایروان",
	weatherClear: "صاف",
	weatherCloudy: "ابری",
	weatherDrizzle: "نمنم باران",
	weatherFog: "مه",
	weatherForecastUnavailable: "پیش‌بینی در دسترس نیست",
	weatherHeadingYerevan: "آب‌وهوای ایروان",
	weatherHumidity: "رطوبت",
	weatherLoadingShort: "آب‌وهوا",
	weatherNextHours: "ساعت‌های آینده",
	weatherPartlyCloudy: "نیمه‌ابری",
	weatherRain: "باران",
	weatherSnow: "برف",
	weatherThunderstorm: "رعد و برق",
	weatherUnknown: "پیش‌بینی",
	weatherWind: "باد",
	weatherWindUnit: "کیلومتر بر ساعت",
	wed: "چهارشنبه",
	weekly: "هفتگی",
	whatToDo: "چه باید کرد",
	whatToDoLink: "چه باید کرد",
	whatsapp: "WhatsApp",
	withAttachments: "با پیوست",
	withCoins: "با سکه",
	withFavorites: "با علاقه‌مندی‌ها",
	workDays: "روزهای کاری",
	workInformation: "اطلاعات کاری",
	workTime: "ساعت کاری",
	workedDays: "روزهای کاری",
	workedHours: "ساعات کار",
	working: "مشغول به کار",
	workingDays: "روزهای کاری",
	workingHoursByDay: "ساعت کاری در روز",
	workingMinutes: "دقایق کاری",
	workingState: "وضعیت کاری",
	workingStatus: "وضعیت کاری",
	write: "بنویس",
	writeUsIfThereAreAnyQuestions: "اگر سوالی دارید برای ما بنویسید",
	writingContent: "محتوای نوشتن",
	writingNumber: "شماره نوشتن",
	yes: "بله",
	yesNextStep: "بله، به مرحله بعد بروید",
	yesPreviousStep: "بله، به مرحله قبلی بروید",
	youWontBeAbleToRevert: "نمی‌توانید این را برگردانید!",
	yourFileHasBeenDeleted: "فایل شما حذف شده است.",
	yourFileHasBeenNotSaved: "فایل شما ذخیره نشده است.",
	yourFileHasBeenSaved: "فایل شما ذخیره شده است.",
	zipCode: "کد پستی",
	zipCodes: "کدهای پستی",
	vacationIntervalNoDeduction: "در روزهای غیرکاری از مرخصی کسر نمی‌شود",
	knowledgeDashboardLoadFailed: "بارگذاری داشبورد ناموفق بود",
	knowledgeArticlesLoadFailed: "بارگذاری مقاله‌ها ناموفق بود",
	knowledgeBase: "پایگاه دانش",
	knowledgeCreate: "ایجاد",
	knowledgeRunAutoDocs: "اجرای اسناد خودکار",
	knowledgeTotalArticles: "کل مقاله‌ها",
	knowledgePublished: "منتشر شده",
	knowledgeDrafts: "پیش‌نویس‌ها",
	knowledgeAutoGenerated: "خودکار ایجاد شده",
	knowledgeLatestUpdatedArticles: "آخرین مقاله‌های به‌روزشده",
	knowledgeArticles: "مقاله‌ها",
	knowledgeNewArticle: "مقاله جدید",
	knowledgeFilterArticles: "فیلتر مقاله‌ها",
	knowledgeCategories: "دسته‌بندی‌ها",
	knowledgeParentCategory: "دسته‌بندی والد",
	knowledgeIcon: "آیکون",
	knowledgeColor: "رنگ",
	knowledgeSortOrder: "ترتیب مرتب‌سازی",
	knowledgeCategorySaved: "دسته‌بندی ذخیره شد",
	knowledgeCategoryDeleted: "دسته‌بندی حذف شد",
	knowledgeSearch: "جستجو",
	knowledgeSearchArticles: "جستجوی مقاله‌ها",
	knowledgePath: "مسیر",
	knowledgeAutoGeneratedDocs: "اسناد خودکار ایجاد شده",
	knowledgeSingleRoute: "مسیر تکی",
	knowledgeNoScreenshots: "بدون اسکرین‌شات",
	knowledgeGenerateDocumentation: "ایجاد مستندات",
	knowledgeImportGeneratedDocs: "وارد کردن اسناد ایجاد شده",
	knowledgeDocumentationGenerationStarted: "ایجاد مستندات شروع شد",
	knowledgeImported: "وارد شد",
	knowledgeGeneratedDocsImported: "{count} سند ایجاد شده وارد شد",
	knowledgeStarted: "شروع شد",
	knowledgeFinished: "پایان یافت",
	knowledgeRun: "اجرا",
	knowledgeOutput: "خروجی",
	knowledgeStatus_draft: "پیش‌نویس",
	knowledgeStatus_published: "منتشر شده",
	knowledgeStatus_archived: "بایگانی شده",
	knowledgeVisibility_public: "عمومی",
	knowledgeVisibility_private: "خصوصی",
	knowledgeVisibility_company: "شرکت",
	knowledgeRunStatus_idle: "بیکار",
	knowledgeRunStatus_running: "در حال اجرا",
	knowledgeRunStatus_completed: "تکمیل شده",
	knowledgeRunStatus_failed: "ناموفق",
	meetings: "جلسات",
	meetingsListSubtitle: "اتاق‌های زمان‌بندی‌شده با گفتگوی APIT و تقویم متصل.",
	meetingsCreateMeeting: "ایجاد جلسه",
	meetingsEditMeeting: "ویرایش جلسه",
	meetingsCreateSubtitle: "جلسه = رویداد تقویم + گروه گفتگو + اتاق ویدیو.",
	meetingsMeetingType: "نوع جلسه",
	meetingsDate: "تاریخ",
	meetingsStartTime: "زمان شروع",
	meetingsEndTime: "زمان پایان",
	meetingsTimezone: "منطقه زمانی",
	meetingsVisibility: "قابلیت مشاهده",
	meetingsParticipants: "شرکت‌کنندگان",
	meetingsGroupsDepartments: "گروه‌ها/بخش‌ها",
	meetingsOptionalGroupIds: "شناسه‌های اختیاری گروه",
	meetingsLocation: "مکان",
	meetingsReminderTime: "زمان یادآوری",
	meetingsMinutesShort: "دقیقه",
	meetingsAgenda: "دستور جلسه",
	meetingsAgendaPlaceholder: "شروع\nبازبینی طراحی\nمراحل بعدی",
	meetingsRecordingEnabled: "ضبط فعال است",
	meetingsAllowJoinBeforeHost: "اجازه ورود قبل از میزبان",
	meetingsMuteUsersOnEntry: "بی‌صدا کردن کاربران هنگام ورود",
	meetingsAllowScreenSharing: "اجازه اشتراک‌گذاری صفحه",
	meetingsSaveAsDraft: "ذخیره به‌عنوان پیش‌نویس",
	meetingsSaveMeeting: "ذخیره جلسه",
	meetingsCreateAndNotifyUsers: "ایجاد و اطلاع‌رسانی به کاربران",
	meetingsSaved: "جلسه ذخیره شد",
	meetingsSaveFailed: "ذخیره جلسه ممکن نبود",
	meetingsJoin: "پیوستن",
	meetingsOpenChat: "باز کردن گفتگو",
	meetingsParticipantsCount: "{count} شرکت‌کننده",
	meetingsType_video: "ویدیو",
	meetingsType_audio: "صوتی",
	meetingsType_in_person: "حضوری",
	meetingsType_hybrid: "ترکیبی",
	meetingsVisibility_private: "خصوصی",
	meetingsVisibility_company: "شرکت",
	meetingsVisibility_department: "بخش",
	meetingsStatus_draft: "پیش‌نویس",
	meetingsStatus_scheduled: "زمان‌بندی شده",
	meetingsStatus_live: "زنده",
	meetingsStatus_ended: "پایان یافته",
	meetingsStatus_cancelled: "لغو شده",
	aiSettingsAction: "کنش",
	aiSettingsAllowedModules: "ماژولهای مجاز",
	aiSettingsApprove: "تایید",
	aiSettingsApprovalFailed: "تایید ناموفق",
	aiSettingsDisabled: "غیرفعال",
	aiSettingsEnabled: "فعال",
	aiSettingsEvent: "رویداد",
	aiSettingsLogs: "گزارشات",
	aiSettingsLoadFailed: "بارگذاری تنظیمات AI ناموفق",
	aiSettingsNoGateway: "درگاه پیکربندی نشده",
	aiSettingsNoPendingApprovals: "هیچ تایید در انتظار نیست",
	aiSettingsNoLogs: "هیچ گزارشی نیست",
	aiSettingsNoPermission: "دسترسی مدیر AI گمشده است.",
	aiSettingsPendingApprovals: "تاییدهای در انتظار",
	aiSettingsReject: "رد کردن",
	aiSettingsRejectFailed: "رد ناموفق",
	aiSettingsRefresh: "تازه‌کردن",
	aiSettingsRequireApproval: "نیاز به تایید",
	aiSettingsStatus: "وضعیت",
	aiSettingsTime: "زمان",
	aiSettingsTitle: "تنظیمات AI",
	aiSettingsTool: "ابزار",
	aiSettingsUser: "کاربر",
	aiSettingsUpdateFailed: "بروزرسانی تنظیمات ناموفق",
	aiSettingsDefaultMode: "حالت پیشفرض",
	aiSettingsReadOnly: "فقط خواندنی",
	aiSettingsApprovalRequired: "تایید مورد نیاز",
	aiSettingsAdminOnly: "فقط مدیر",
	financeActiveCurrencies: "{count} واحد پول فعال",
	financeAddCurrency: "افزودن ارز",
	financeCurrencyCode: "کد",
	financeCurrencyCoefficient: "ضریب",
	financeCurrencyDefault: "پیشفرض",
	financeCurrencyName: "نام",
	financeCurrencySymbol: "نماد",
	financeCurrencyUse: "استفاده کنید",
	financeLoadFailed: "بارگذاری تنظیمات مالی ناموفق",
	financeSaveSettings: "ذخیره تنظیمات",
	financeSavedMessage: "تنظیمات مالی ذخیره شده",
	financeSaveFailed: "ذخیره تنظیمات مالی ناموفق",
	financeSelectedDefault: "پیشفرض انتخاب شده:",
	financeSettingsSubtitle: "ارزهای اینجا نمایش پول پیشفرض را در صفحات مالی و سفارش کنترل می‌کنند.",
	financeSettingsTitle: "تنظیمات مالی",
	hrAccrualCoeffPreview: "پیش‌نمایش ضریب",
	hrAccrualCoeffPreviewLine1: "{accrualWorkedHours} ساعت کار → {accrualVacationHours} ساعت تعطیل",
	hrAccrualCoeffPreviewLine2: "ساعات تعطیل کسب شده در هر ساعت کار: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"بخش پشتیبانی این تعهد را بر حسب دقیقه ذخیره می‌کند تا حقوق و بدهی‌های مرخصی بتوانند از مقادیر روز جزئی بدون انحراف گرد شدن استفاده کنند.",
	hrAccrualFixedYearly: "روزهای تعطیل سالانه ثابت",
	hrAccrualFixedYearlyDesc:
		"تعداد تعیین‌شدهٔ روزهای تعطیل را در سراسر سال با استفاده از برنامه روزانه یا ماهانهٔ موجود تعهد کنید.",
	hrAccrualModelChoice:
		"یک مدل تعهد فعال را انتخاب کنید. روزهای سالانه و ضریب ساعات کار از منطق OR استفاده می‌کنند، نه ترکیب شده.",
	hrAccrualSuffixMin: "دقیقه",
	hrAccrualVacationMinutesEarned: "دقایق تعطیل کسب شده",
	hrAccrualVacationMinutesEarnedDesc: "تعداد دقایق تعطیل برای هر واحد زمان کار تعهد شده.",
	hrAccrualWorkBreak: "وقفهٔ کار",
	hrAccrualWorkBreakDesc:
		"دقایق روزانهٔ پوشش داده نشده که به عنوان وقفه در فاصل غیابی از دفتر طبقه‌بندی شده‌اند.",
	hrAccrualWorkedHoursModel: "ساعات کار تا ساعات تعطیل",
	hrAccrualWorkedHoursModelDesc:
		"زمان کار واقعی را با استفاده از ضریب ساعات کار قابل تنظیم تعهد کنید.",
	hrAccrualWorkedMinutesUnit: "واحد دقایق کار",
	hrAccrualWorkedMinutesUnitDesc: "چند دقیقه کار باید یک واحد تعهد را تولید کند.",
	hrWeekdayFri: "جمعه",
	hrWeekdayMon: "دوشنبه",
	hrWeekdaySat: "شنبه",
	hrWeekdaySun: "یکشنبه",
	hrWeekdayThu: "پنج‌شنبه",
	hrWeekdayTue: "سه‌شنبه",
	hrWeekdayWed: "چهارشنبه",
	knowledgeSettingsAiEnabled: "AI فعال است",
	knowledgeSettingsAiModel: "مدل AI",
	knowledgeSettingsAiProvider: "تامین‌کننده AI",
	knowledgeSettingsEnableAutoDocs: "فعال‌کردن اسناد خودکار",
	knowledgeSettingsLanguage: "زبان پیشفرض",
	knowledgeSettingsMaxSizeMb: "حداکثر اندازهٔ مقاله MB",
	knowledgeSettingsRootCategory: "دستهٔ ریشهٔ اسناد خودکار",
	knowledgeSettingsSaveSettings: "ذخیره تنظیمات",
	knowledgeSettingsSaved: "تنظیمات دانشنامه بروزرسانی شد",
	knowledgeSettingsTitle: "تنظیمات",
	knowledgeSettingsUploadExt: "پسوندهای بارگذاری مجاز",
	knowledgeSettingsVisibility: "دید پیشفرض",
	nvrAddFromList: "افزودن دوربین از فهرست",
	nvrCamerasList: "فهرست دوربین",
	nvrChannel: "کانال",
	nvrChannelId: "شناسه",
	nvrChannelName: "نام",
	nvrChannelsTitle: "کانالهای ثبت‌شده از این NVR",
	nvrConnectionDesc:
		"IP، درگاه و الگوی مسیر را وارد کنید (تنها /.../{channel}... — مانند VLC، بدون بخش rtsp://). نام کاربری و رمز RTSP را اضافه کنید (بیشتر NVRها نیاز دارند). برای اجرای اسکن شبکهٔ خودکار روی ذخیره کلیک کنید، یا از «افزودن دوربین از مسیرها» در زیر استفاده کنید تا کانالها را بدون اسکن ثبت کنید. دوربین را برای مشاهدهٔ بلاصرف باز کنید؛ روی نقشهٔ دفتر، دستگاهها را به طور معمول قرار دهید.",
	nvrConnectionTitle: "NVR — یک اتصال برای تمام کانالها",
	nvrDiscoveryFailed: "کشف ناموفق",
	nvrEnterPaths: "حداقل یک کانال یا مسیر وارد کنید.",
	nvrFoundChannels: "{n} کانال پیدا شد.",
	nvrFullUrl: "URL کامل (کانال 101 — خودکار از فیلدهای بالا)",
	nvrInitError: "NVR نمی‌تواند اولیه شود. صفحه را دوباره بارگذاری کنید.",
	nvrIp: "IP NVR",
	nvrIpPasswordRequired:
		"IP NVR و رمز ذخیره‌شده لازم است. رمز را تنظیم کنید، ذخیره کنید و ما در ذخیرهٔ بعدی کانالها را اسکن می‌کنیم.",
	nvrLoadFailed: "بارگذاری NVR ناموفق",
	nvrLiveStatus: "وضعیت بلاصرف",
	nvrManualDesc:
		"هنگام شکست اسکن خودکار (مثلاً API نمی‌تواند به NVR دسترسی پیدا کند)، کانالها را اینجا فهرست کنید. یکی در هر سطر استفاده کنید: شماره کانالها مانند 101، 201، مسیری مانند /Streaming/Channels/102 یا URL rtsp:// کامل. مسیرها با الگوی مسیر RTSP شما ترکیب می‌شوند زمانی که فقط اعداد را وارد می‌کنید. اگر IP یا الگو را تغییر داده‌اید، ابتدا NVR را ذخیره کنید، سپس ردیفها را اضافه کنید و روی دکمه کلیک کنید.",
	nvrManualTitle: "افزودن دوربین از مسیرهای RTSP (بدون اسکن سرور)",
	nvrNotReady: "NVR آماده نیست. صفحه را دوباره بارگذاری کنید.",
	nvrNotReadyShort: "NVR آماده نیست.",
	nvrNotWorking: "کار نمی‌کند",
	nvrOfficeMap: "نقشهٔ دفتر",
	nvrOffline: "آفلاین",
	nvrOnline: "آنلاین",
	nvrPasswordChangeNote: "تغییر دهید و ذخیره کنید تا رمز ذخیره‌شده را بروزرسانی کنید.",
	nvrPasswordLeaveBlank: "برای حفظ رمز فعلی خالی بگذارید",
	nvrPasswordRequired: "بیشتر NVRها برای کشف کانالها و جریان لازم است.",
	nvrPasswordStoredLeaveBlank: "رمز ذخیره‌شده است؛ برای حفظ آن خالی بگذارید یا رمز جدید بنویسید.",
	nvrRegisterFailed: "ثبت مسیرها ناموفق",
	nvrRegisteredCameras: "{n} دوربین ثبت شده.",
	nvrRtspPassword: "رمز RTSP",
	nvrRtspPathTemplate: "الگوی مسیر RTSP",
	nvrRtspPathTemplateHint:
		"فقط مسیر را با {channel} بنویسید. رشتهٔ rtsp:// کامل را اینجا وارد نکنید.",
	nvrRtspUsername: "نام کاربری RTSP",
	nvrScanChannels: "اسکن کانالها دوباره",
	nvrScanHint: "این فیلدهای اتصال فعلی را ذخیره می‌کند، سپس اسکن می‌کند.",
	nvrWorkingState: "وضعیت کاری",
	nvrWorking: "کار می‌کند",
	nvrGridEmpty: "هنوز هیچ کانالی به این NVR متصل نشده است. کشف را روی صفحهٔ NVR اجرا کنید.",
	nvrGridLoadFailed: "بارگذاری کانالها ناموفق",
	nvrGridLoading: "بارگذاری کانالها…",
	nvrGridStreamFailed: "شروع ناموفق",
	nvrGridStreamStopped: "جریان متوقف شد",
	nvrGridTitle: "تمام کانالهای NVR",
	securityRecordingActiveDays: "روزهای فعال",
	securityRecordingDesc:
		"ضبط سمت سرور را برای دوربین‌هایی فعال کنید که «ضبط روی سرور» را فعال کردند. هر دوربین می‌تواند برنامه‌ای خود را نیز در زیر داشته باشد.",
	securityRecordingEndTime: "زمان پایان",
	securityRecordingGlobalEnable: "فعال‌کردن ضبط جهانی",
	securityRecordingGlobalEnableDesc:
		"سوئیچ اصلی — غیرفعال‌کردن این مورد تمام ضبط‌ها را متوقف می‌کند صرف‌نظر از تنظیمات هر دوربین.",
	securityRecordingLoadFailed: "بارگذاری تنظیمات امنیتی ناموفق",
	securityRecordingLocalFs: "سیستم فایل محلی",
	securityRecordingLocalPathNote:
		"مسیر محلی از طریق متغیر محیط SECURITY_RECORDING_LOCAL_PATH روی سرور پیکربندی می‌شود.",
	securityRecordingNoScheduleNote:
		"بدون برنامه — دوربین‌ها 24/7 ضبط می‌شوند زمانی که ضبط روی سرور فعال است.",
	securityRecordingRetentionDays: "حفظ (روز)",
	securityRecordingRetentionDesc: "بخش‌های قدیمی‌تر خودکار حذف می‌شوند.",
	securityRecordingS3: "S3 / ذخیرهٔ اشیاء سازگار",
	securityRecordingS3Note:
		"اعتبارات S3 از طریق متغیرهای محیط روی سرور پیکربندی می‌شوند (AWS_ACCESS_KEY_ID، AWS_SECRET_ACCESS_KEY، و غیره).",
	securityRecordingSaveSettings: "ذخیره تنظیمات",
	securityRecordingSaved: "تنظیمات امنیتی ذخیره شده.",
	securityRecordingSaveFailed: "ذخیره تنظیمات ناموفق",
	securityRecordingScheduleDesc:
		"این برنامه برای تمام دوربین‌هایی با ضبط روی سرور فعال‌شده و بدون لغو برنامهٔ هر دوربین تطبیق می‌یابد.",
	securityRecordingScheduleEnable: "فعال‌کردن برنامهٔ پیشفرض (ضبط فقط در ساعات تعیین‌شده)",
	securityRecordingScheduleNote:
		"ضبط در روزهای انتخاب‌شده بین این ساعات اجرا می‌شود. خارج این پنجره، ضبط خودکار متوقف می‌شود.",
	securityRecordingScheduleTitle: "برنامهٔ ضبط پیشفرض",
	securityRecordingSegmentLength: "طول بخش (دقیقه)",
	securityRecordingSegmentLengthDesc:
		"این کنترل می‌کند که ویدیوی جدید چقدر اوقات روی هر صفحهٔ دوربین ظاهر شود.",
	securityRecordingStartTime: "زمان شروع",
	securityRecordingStorage: "ذخیره‌سازی",
	securityRecordingStorageBackend: "بخش پشتیبانی ذخیره‌سازی",
	securityRecordingTitle: "ضبط دوربین روی سرور",
	securitySurveillanceCameraMedia: "رسانهٔ دوربین",
	securitySurveillanceDashboard: "داشبورد نظارت",
	securitySurveillanceNoCameras: "دوربینی یافت نشد.",
	securitySurveillanceOffline: "آفلاین",
	securitySurveillanceOnline: "آنلاین",
	teamWorkload: "حجم کار تیم",
	workloadTasks: "وظایف",
	workloadTickets: "تیکت‌ها",
	workloadSteps: "مراحل",
	assignedEmployee: "کارمند اختصاص‌یافته",
	boughtDate: "تاریخ خرید",
	broken: "خراب",
	depreciation: "استهلاک",
	deviceStatus: "وضعیت دستگاه",
	handoverDocument: "سند تحویل",
	maintenanceSchedule: "برنامه نگهداری",
	qrCode: "کد QR",
	repair: "تعمیر",
	repairHistory: "سابقه تعمیرات",
	replacementDate: "تاریخ جایگزینی",
	retired: "از رده خارج",
	returnDocument: "سند بازگشت",
	warrantyDate: "تاریخ گارانتی",
	noOpenWorkload: "حجم کار باز وجود ندارد",
	attendanceTable: "جدول حضور و غیاب",
	filteredFrom: "فیلتر شده از",
	weekend: "آخر هفته",
	late: "دیرکرد",
	lateDeparture: "خروج دیرهنگام",
	employees: "کارمندان",
	exportToExcel: "خروجی Excel",
	overtime: "اضافه‌کاری",
	attendanceNextRefresh: "به‌روزرسانی بعدی",
	refreshAttendanceDevices: "به‌روزرسانی داده‌ها از دستگاه‌های حضور و غیاب",
	attendanceSyncSuccess: "دستگاه‌های حضور و غیاب همگام شدند",
	attendanceSyncFailed: "همگام‌سازی دستگاه‌های حضور و غیاب ناموفق بود",
	// User account security / profile
	contactInformation: "اطلاعات تماس",
	accountSecurity: "امنیت حساب",
	accountStatus: "وضعیت حساب",
	accountStatusActive: "فعال",
	accountStatusLocked: "قفل‌شده",
	mustChangePassword: "باید رمز عبور را تغییر دهد",
	lockedAt: "زمان قفل",
	passwordLastChanged: "آخرین تغییر رمز عبور",
	accountSecurityDesc: "رمزهای عبور فعلی هرگز نمایش داده نمی‌شوند. هنگام نیاز به تغییر اعتبارنامه‌ها از رمز موقت یا پیوند بازنشانی امن استفاده کنید.",
	accountSecurityHint: "برای چرخش فوری اعتبارنامه‌ها از «بازنشانی رمز عبور» استفاده کنید. اگر کاربر باید رمز جدید را بدون دیدن هیچ رازی توسط مدیر انتخاب کند، از «ارسال پیوند بازنشانی» استفاده کنید.",
	lockAccount: "قفل کردن حساب",
	unlockAccount: "باز کردن قفل حساب",
	forcePasswordChangeAction: "اجبار به تغییر رمز عبور",
	clearForcedPasswordChange: "حذف اجبار تغییر رمز عبور",
	resetPassword: "بازنشانی رمز عبور",
	sendResetLink: "ارسال پیوند بازنشانی",
	sessionVisibilityRequiresPermission: "مشاهده نشست‌ها و دستگاه‌ها به مجوز اضافی نیاز دارد.",
	resetPasswordConfirmTitle: "این رمز عبور بازنشانی شود؟",
	resetPasswordConfirmText: "یک رمز موقت ایجاد می‌شود و کاربر باید آن را در ورود بعدی تغییر دهد.",
	temporaryPasswordGenerated: "رمز موقت ایجاد شد",
	temporaryPasswordShareHint: "فقط از طریق کانال امن به اشتراک بگذارید.",
	sendResetLinkConfirmTitle: "پیوند بازنشانی رمز عبور ارسال شود؟",
	sendResetLinkConfirmText: "یک پیوند بازنشانی امن یک‌بارمصرف به ایمیل این کاربر ارسال می‌شود.",
	passwordResetLinkSent: "پیوند بازنشانی رمز عبور ارسال شد.",
	lockAccountConfirmTitle: "این حساب قفل شود؟",
	unlockAccountConfirmTitle: "قفل این حساب باز شود؟",
	lockAccountConfirmText: "کاربر تا زمان باز شدن قفل نمی‌تواند وارد شود.",
	unlockAccountConfirmText: "کاربر می‌تواند بلافاصله دوباره وارد شود.",
	accountLockedMsg: "حساب قفل شد.",
	accountUnlockedMsg: "قفل حساب باز شد.",
	forcePasswordChangeConfirmTitle: "در ورود بعدی تغییر رمز اجباری شود؟",
	removeForcedPasswordChangeConfirmTitle: "اجبار تغییر رمز حذف شود؟",
	forcePasswordChangeConfirmText: "کاربر فقط برای تکمیل تغییر رمز قبل از استفاده از پلتفرم می‌تواند وارد شود.",
	removeForcedPasswordChangeConfirmText: "کاربر می‌تواند به‌طور عادی به ورود ادامه دهد.",
	forcedPasswordChangeEnabled: "اجبار تغییر رمز فعال شد.",
	forcedPasswordChangeRemoved: "اجبار تغییر رمز حذف شد.",
	securityUpdated: "امنیت به‌روز شد",
	securityActionFailed: "عملیات امنیتی ناموفق بود",
	knownDevicesAndSessions: "دستگاه‌های شناخته‌شده و نشست‌های باز",
	knownDevicesAndSessionsDesc: "موقعیت‌ها تقریبی هستند و معمولاً مبدأ IP، ISP، خروجی VPN یا دروازه دفتر را نشان می‌دهند نه موقعیت فیزیکی دقیق دستگاه.",
	openSessionsBadge: "{count} باز",
	revokeOtherSessions: "لغو نشست‌های دیگر",
	registeredDevices: "دستگاه‌های ثبت‌شده",
	unknownDevice: "دستگاه ناشناخته",
	unknownBrowser: "مرورگر ناشناخته",
	unknownOs: "سیستم‌عامل ناشناخته",
	browserOnOs: "{browser} روی {os}",
	firstSeen: "اولین مشاهده",
	sessionsBadge: "{count} نشست",
	currentDevice: "دستگاه فعلی",
	noKnownDevices: "هنوز دستگاه شناخته‌شده‌ای ثبت نشده است.",
	approximateLoginOrigins: "مبدأهای تقریبی ورود",
	sessionDetails: "جزئیات نشست",
	device: "دستگاه",
	network: "شبکه",
	lastActive: "آخرین فعالیت",
	approximateLocationUnavailable: "موقعیت تقریبی در دسترس نیست",
	revoke: "لغو",
	noAuthSessions: "هنوز نشست احراز هویت ثبت نشده است.",
	sessionOriginApproximateNote: "داده‌های مبدأ نشست تقریبی هستند. مکان‌یابی جغرافیایی IP را موقعیت دقیق دستگاه ندانید.",
	connectedMeansNote: "«متصل» یعنی مرورگر/برنامه هنوز سوکت زنده دارد. «قطع» یعنی مرورگر بسته یا آفلاین شده، اما نشست ورود ذخیره‌شده ممکن است تا خروج، لغو یا انقضا معتبر بماند.",
	revokeThisSessionTitle: "این نشست لغو شود؟",
	revokeThisSessionText: "دستگاه/نشست انتخاب‌شده مجبور به ورود مجدد می‌شود.",
	revokeSession: "لغو نشست",
	sessionRevoked: "نشست لغو شد",
	sessionRevokedSuccess: "نشست انتخاب‌شده با موفقیت لغو شد.",
	failedToRevokeSession: "لغو نشست ناموفق بود",
	unableToRevokeSession: "لغو نشست انتخاب‌شده ممکن نیست.",
	revokeOtherSessionsTitle: "نشست‌های دیگر لغو شوند؟",
	revokeOtherSessionsText: "همه نشست‌های این کاربر به‌جز نشست فعلی (وقتی کاربر دستگاه‌های خودش را لغو می‌کند) لغو می‌شوند.",
	revokeSessions: "لغو نشست‌ها",
	sessionsRevoked: "نشست‌ها لغو شدند",
	revokedSessionsCount: "{count} نشست لغو شد.",
	failedToRevokeSessions: "لغو نشست‌ها ناموفق بود",
	unableToRevokeSessions: "لغو نشست‌های انتخاب‌شده ممکن نیست.",
	failedToLoadSessions: "بارگذاری نشست‌ها ناموفق بود",
	unableToLoadUserSessions: "بارگذاری نشست‌های کاربر ممکن نیست.",
	sessionStatusRevoked: "لغو شده",
	sessionStatusConnected: "متصل",
	sessionStatusDisconnected: "قطع",
	currentSession: "فعلی",
	passwordChangeOnly: "فقط تغییر رمز عبور",
	faceId: "Face ID",
	passwordsNeverShownHint: "رمزهای عبور اینجا نمایش داده نمی‌شوند. از زبانه امنیت برای قفل/باز کردن حساب، اجبار تغییر رمز، ایجاد رمز موقت یا ارسال پیوند بازنشانی استفاده کنید.",
	sharedFolders: "پوشه‌های اشتراکی",
	flexId: "Flex Id",
	emailNotProvided: "ایمیل ارائه نشده",
	anonymousUser: "کاربر ناشناس",
	noMapPointsYet: "هنوز نقطه نقشه وجود ندارد",
	noMapPointsYetDesc: "هنوز مکان نشست با مختصات تقریبی در دسترس نیست. بک‌اند می‌تواند بدون ارائه‌دهنده جغرافیایی دستگاه‌ها و نشست‌ها را ردیابی کند.",
	googleMapsKeyNotConfigured: "کلید Google Maps پیکربندی نشده",
	googleMapsKeyNotConfiguredDesc: "برای نمایش نقشه تقریبی نشست‌ها REACT_APP_GOOGLE_MAPS_API_KEY را تنظیم کنید.",
	mapFailedToLoad: "بارگذاری نقشه ناموفق بود",
	mapFailedToLoadDesc: "در حال حاضر بارگذاری Google Maps ممکن نیست.",
	approximateLocation: "موقعیت تقریبی",
	attendanceLastRefreshed: "آخرین به‌روزرسانی",
	quarter: "سه‌ماهه",
	year: "سال",
	currentQuarter: "سه‌ماهه جاری",
	currentYear: "سال جاری",
	chatClearHistory: "پاک کردن تاریخچه",
	chatClearHistoryConfirm: "تاریخچه این گفتگو فقط برای شما پاک شود؟",
	chatDeleteForMe: "حذف گفتگو",
	chatDeleteForMeConfirm: "این گفتگو فقط برای شما حذف شود؟ تاریخچه قابل مشاهده شما پاک می‌شود و گفتگو از نوار کناری شما ناپدید می‌شود.",
	chatBlockUser: "مسدود کردن کاربر",
	chatUnblockUser: "رفع مسدودیت کاربر",
	chatBlockedSection: "مخاطبین مسدود شده",
	chatBlockUserConfirm: "این کاربر مسدود شود؟ او نمی‌تواند در این گفتگو برای شما پیام بفرستد.",
};
